import React, { useCallback, useEffect, useMemo, useReducer, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { connect } from 'react-redux'
import {
  postArtemisQuestion,
  dislikeOnSuggestionQuestion,
  feedbackOnAnswer,
  feedbackCommentOnAnswer,
  fetchSuggestedQuestions,
  fetchArtemisModels,
  createArtemisConversation as createArtemisConversationAction,
  fetchArtemisConversations as fetchArtemisConversationsAction,
  fetchArtemisConversationMessages as fetchArtemisConversationMessagesAction,
  deleteArtemisConversation as deleteArtemisConversationAction,
  cancelArtemisMessage as cancelArtemisMessageAction,
  artemisMessageFeedback as artemisMessageFeedbackAction,
  postArtemisConversationMessage as postArtemisConversationMessageAction,
  fetchArtemisView as fetchArtemisViewAction,
  fetchArtemisSkills as fetchArtemisSkillsAction,
  fetchArtemisBuiltInSkills as fetchArtemisBuiltInSkillsAction,
  fetchArtemisBuiltInSkill as fetchArtemisBuiltInSkillAction,
  createArtemisSkill as createArtemisSkillAction,
  updateArtemisSkill as updateArtemisSkillAction,
  deleteArtemisSkill as deleteArtemisSkillAction,
  transcribeArtemisAudio as transcribeArtemisAudioAction,
  speakArtemisText as speakArtemisTextAction,
  fetchArtemisVoices as fetchArtemisVoicesAction,
  fetchArtemisScratch as fetchArtemisScratchAction,
  addArtemisScratchItem as addArtemisScratchItemAction,
  deleteArtemisScratchItem as deleteArtemisScratchItemAction,
  updateArtemisScratchItem as updateArtemisScratchItemAction,
  sendArtemisScratch as sendArtemisScratchAction,
  fetchArtemisMembers as fetchArtemisMembersAction,
  addArtemisMembers as addArtemisMembersAction,
  removeArtemisMember as removeArtemisMemberAction,
  updateArtemisConversation as updateArtemisConversationAction,
  fetchArtemisMentions as fetchArtemisMentionsAction,
  createArtemisInvite as createArtemisInviteAction,
  acceptArtemisInvite as acceptArtemisInviteAction,
  setArtemisTyping as setArtemisTypingAction,
  pollArtemisMessages as pollArtemisMessagesAction,
  markArtemisRead as markArtemisReadAction,
  fetchArtemisFriends as fetchArtemisFriendsAction,
  fetchArtemisUsage as fetchArtemisUsageAction,
  fetchArtemisAlerts as fetchArtemisAlertsAction,
  updateArtemisAlert as updateArtemisAlertAction,
  deleteArtemisAlert as deleteArtemisAlertAction,
  fetchArtemisAlertSettings as fetchArtemisAlertSettingsAction,
  saveArtemisAlertSettings as saveArtemisAlertSettingsAction
} from "../../../action/artemis-actions/query-action";
import '../index.scss'
import '../artemis-panel.scss'
import { userHasPro } from "../../../lib/util";
import { showHideSubscriptionModal } from "../../../utils/subscriptionUtils";
import { collapseLeftToolbar as collapseLeftToolbarAction } from "../../../action/left-toolbar-state-actions";
import { chatReducer, newMessageId } from "../../../lib/artemis/chat-reducer";
import { isAbortError } from "../../../lib/artemis/stream";
import { atStartView, chatHistory, mapContext, visibleOverlayLayerIds, activeBasemapLayerId, answerToText, selectionFor, homeStateCode } from "../../../lib/artemis/context";
import {
  archiveCurrentChat, currentChat, openPastChat, pastChats, setCurrentChat, currentConversationId, setCurrentConversationId
} from "../../../lib/artemis/session";
import { conversationRow, mergeEarlier, messagesFromConversation, newClientMessageId } from "../../../lib/artemis/conversations";
import useSavedChats from "./useSavedChats";
import { normalizeView, viewAreaRow, viewLabel } from "../../../lib/artemis/view";
import { nextSpeech } from "../../../lib/artemis/voice";
import { SkillForm, SkillsView, WelcomeSkills, useUserSkills } from "./userSkills";
import { useDictation, useServerDictation, useSpeaker } from "./useVoice";
import { chatSubtitle, costLabel, groupChats, matchChats, timeLabel } from "../../../lib/artemis/present";
import { isAsking } from "../../../lib/artemis/ask";
// Aliased so the mapDispatchToProps entries can't call themselves: see scripts/check-dispatch-recursion.js.
import {
  ARTEMIS_AGENT_ENABLED,
  ARTEMIS_CONVERSATIONS_ENABLED,
  handleArtemisAgentEvent as handleArtemisAgentEventAction,
  refreshAfterArtemisReply as refreshAfterArtemisReplyAction,
  runSetLayerVisibility as runSetLayerVisibilityAction,
  showArtemisObject as showArtemisObjectAction,
  removeArtemisObject as removeArtemisObjectAction,
  showArtemisOverlay as showArtemisOverlayAction,
  moveArtemisMap as moveArtemisMapAction,
  runSetMapView as runSetMapViewAction,
  clearArtemisOverlay as clearArtemisOverlayAction,
  isObjectCreatingTool
} from "../../../action/artemis-actions/agent-actions";
import Icon from "./icons";
import { ARTEMIS_PLANNER_ACTIONS, PLANNER_INTAKE_OPENER, plannerContext } from "../../../lib/artemis/planner";
import { markerTypeOptions, scratchFromStep } from "../../../lib/artemis/scratchpad";
import { isGroup, membersLine, mentionOptions, mentionsFromText, mentionsToToast, mentionToastText, mergePolled, typingLine, TYPING_EVERY_MS } from "../../../lib/artemis/group";
import { MembersPanel, SessionMenu } from "./sessionMenu";
import { dismissNotice, dismissedNotice, noticeKey, usageNotice, usageState } from "../../../lib/artemis/usage";
import InvitePanel from "./invitePanel";
import UsageMenu, { CREDITS_PAGE, UsageButton } from "./usageMenu";
import Avatar from "./avatar";
import { drawnOverlayIds, initialScratchLayers, readScratchLayers, requestScratchLayer, scratchLayerChoices, writeScratchLayers } from "../../../lib/artemis/scratchLayers";
import { readView as readMapView, viewFromInput } from "../../../lib/artemis/map-view";
import useScratchpad from "./useScratchpad";
import Scratchpad from "./scratchpad";
import { fetchChanges as fetchChangesAction } from "../../../action/changes-last-called-actions";
import Turn from "./turn";
import { AlertMessage } from "./alertCards";
import { applyDeepLinkLayers as applyDeepLinkLayersAction } from "../../../action/map-deep-link-actions";
import { runSetPlannerFilters as runSetPlannerFiltersAction } from "../../../action/artemis-actions/agent-actions";
import { huntPlannerActiveOptions as huntPlannerActiveOptionsAction } from "../../../action/huntplanner-selected-options";
import { selectedTabAction } from "../../../action/selected-tab-action";
import { AlertsView, useAlerts } from "./alertsView";
import { alertMatches, alertReadState, isAlertsChat, pinAlerts, repliesAbout } from "../../../lib/artemis/alerts";
import { AlertDetail, AlertHeader, AlertList, AlertsRight } from "./alertsHub";
import Composer from "./composer";
import VoiceMenu from "./voiceMenu";
import { ConversationList, HubRail, SeesPanel } from "./hub";
import { MethodsColumn, SkillEditor, SkillList } from "./skillsHub";
import { draftFromBuiltIn, emptySkillForm, startsRewrite } from "../../../lib/artemis/skills";
import { badgeStore, filteredRows, hasListFilters, hubBadges, isSession, listFilter, readOpenedSessions, rememberSession, requestSection, sectionFor, takeRequestedSection } from "../../../lib/artemis/hub";

// The Artemis panel (agent panel redesign): a one-line header, the welcome screen or the chat,
// past chats, and the composer. Map changes also show as a toast over the map. Built with
// ARTEMIS_CONVERSATIONS=true, chats are saved on the v3 Conversations routes (API-3641); otherwise
// they last for the page's lifetime.

// Example questions on the welcome screen, as cards grouped by topic: the Basemap Home v2
// design's map questions, word for word, with or without agent mode.
const STARTER_SECTIONS = [
  { name: 'Wind & Weather', items: [
    'Which way will the wind blow tomorrow morning?',
    'When will thermals switch on this slope?',
    'Is a storm or cold front moving in this week?',
    'When is legal shooting light tomorrow?'
  ] },
  { name: 'Terrain', items: [
    'Where are the best glassing spots near me?',
    'Where would elk bed down in this area?',
    'Where are the saddles and pinch points here?',
    'How steep is the hike to this ridge?'
  ] },
  { name: 'Hunt Planning', items: [
    'Can you build me a 3-day hunt plan here?',
    'Which unit gives me the best odds?',
    'When does the season open in this unit?',
    'Where can I park and camp near public land?'
  ] }
]

// Hunt Planner's starting points (the design's planner presets): each a title, a line under it,
// and the question it asks. The first starts the guided intake.
export const PLANNER_STARTERS = [
  { title: 'Build my hunt plan', sub: 'Day-by-day, scouting to pack-out', q: 'Build a day-by-day hunt plan for this area, from scouting to pack-out.' },
  { title: 'Pick a unit', sub: 'Compare units for my species', q: 'Compare the hunting units in this area for my species and weapon.' },
  { title: 'Seasons & tags', sub: 'Dates, draw odds, deadlines', q: 'What are the season dates, draw odds and application deadlines for this unit?' },
  { title: 'Glassing spots', sub: 'Vantage points & sight lines', q: 'Find the best glassing spots in this area and how to reach them.' },
  { title: 'Water, feed & bedding', sub: 'Where animals will be', q: 'Where are the likely water, feeding and bedding areas here?' },
  { title: 'Access & camp', sub: 'Trailheads, roads, campsites', q: 'Where can I park, enter public land and set up camp for this hunt?' }
]

const RECENT_COUNT = 3

const TOAST_MS = 5000
// The "@you" toast (group chats): unread mentions are checked this often, and each is toasted once a page load,
// whichever Artemis panel sees it first.
const MENTIONS_EVERY_MS = 30000
const MENTIONS_SEEN = new Set()
const MENTIONS_LOOKED = { first: true }
// Whether this server has Transcribe; a 404 turns it off for the page (API-3691).
const TRANSCRIBE = { available: true }
// What's been read aloud of each reply this page load ({ plan, muted }), so reopening the panel
// doesn't read it again and a reply that was stopped stays quiet.
const READ = new Map()

// Where conversations are off there's no alerts inbox either: every Alerts call is a 404.
const noAlerts = () => Promise.reject(Object.assign(new Error('HTTP 404'), { code: 'http_404', status: 404 }))
const NO_ALERTS = { list: noAlerts, update: noAlerts, remove: noAlerts, settings: noAlerts, saveSettings: noAlerts }
// How long the map has to be still before the view is named again.
const VIEW_LOOKUP_DEBOUNCE_MS = 700
const VIEW_RETRY_MS = 1500

const MapToast = ({ toast, onAction }) => {
  if (!toast) return null
  return ReactDOM.createPortal(
    <div className="artemis-map-toast" role="status">
      <span className="artemis-chip-live"><Icon name="sparkle" size={16} /></span>
      <span>{toast.text}</span>
      {toast.button && <button type="button" onClick={onAction}>{toast.button}</button>}
    </div>,
    document.body
  )
}

export const Welcome = ({ surface = 'map', ...rest }) => (surface === 'planner' ? <PlannerWelcome {...rest} />
  : surface === 'full' ? <MapWelcome {...rest} heading="What are we scouting?" blurb="Ask about your map, a unit or a hunt. Your chats are saved on the left." />
  : surface === 'session' ? <MapWelcome {...rest} heading="What are we scouting?" blurb="Artemis keeps what it finds on the scratchpad until you send it to your map. Invite a partner to plan it together." />
  : <MapWelcome {...rest} />)

// Hunt Planner: the design's greeting and its starting points as one card of titled buttons.
const PlannerWelcome = ({ onAsk }) => (
  <>
    <div className="artemis-welcome">
      <span className="artemis-eyebrow artemis-welcome-tag">Hunt Planner</span>
      <h2 className="artemis-welcome-title">Let’s plan your hunt.</h2>
      <p className="artemis-welcome-text">Pick a starting point or describe your hunt. Artemis asks a few questions, then sets up the planner and walks you through the units.</p>
    </div>
    <section className="artemis-question-card" aria-label="Starting points">
      <div className="artemis-question-grid">
        {PLANNER_STARTERS.map(p => (
          <button key={p.title} type="button" className="artemis-question artemis-question-titled" onClick={() => onAsk(p.q)}>
            <span className="artemis-question-title">{p.title}</span>
            <span className="artemis-question-sub">{p.sub}</span>
          </button>
        ))}
      </div>
    </section>
  </>
)

const MapWelcome = ({ onAsk, recentChats, onOpenChat, onViewAll, mapView, skillsSection, heading, blurb }) => (
  <>
    <div className="artemis-welcome">
      <h2 className="artemis-welcome-title">{heading || 'Hi, I’m Artemis.'}</h2>
      <p className="artemis-welcome-text">
        {blurb || (ARTEMIS_AGENT_ENABLED
          ? 'Ask me anything. I can read this view, check regulations and draw dates, search hunting sources, change your layers and save spots to your map.'
          : "I'm here to answer your questions about hunting.")}
      </p>
    </div>
    <div className="artemis-card-list">
      <span className="artemis-eyebrow">{viewLabel(mapView) ? `Example questions · ${viewLabel(mapView)}` : 'Example questions'}</span>
      {STARTER_SECTIONS.map(section => (
        <section key={section.name} className="artemis-question-card" aria-label={section.name}>
          <h3 className="artemis-question-card-head"><span className="artemis-question-card-bar" />{section.name}</h3>
          <div className="artemis-question-grid">
            {section.items.map(q => (
              <button key={q} type="button" className="artemis-question" onClick={() => onAsk(q)}>{q}</button>
            ))}
          </div>
        </section>
      ))}
    </div>
    {recentChats.length > 0 && (
      <div className="artemis-card-list">
        <div className="artemis-recent-head">
          <span className="artemis-eyebrow artemis-flex">Recent</span>
          <button type="button" className="artemis-link-button artemis-view-all" onClick={onViewAll}>View all</button>
        </div>
        <div className="artemis-recent">
          {recentChats.map(chat => (
            <button key={chat.id} type="button" className="artemis-recent-row" onClick={() => onOpenChat(chat.id)}>
              <Icon name="chat" size={14} />
              <span className="artemis-recent-title">{chat.title}</span>
              {chat.time && <span className="artemis-recent-time">{chat.time}</span>}
            </button>
          ))}
        </div>
      </div>
    )}
    {skillsSection}
  </>
)

// One chat in history: its title and when, then its last message. Archive (undone from its toast) and
// Delete, which asks first; the alerts inbox has neither.
const HistoryRow = ({ chat, onOpen, onDelete, onArchive, active = false }) => {
  // A shared session someone else owns is left, not deleted (DELETE does that for a member).
  const leaves = chat.kind === 'group' && chat.owner === false
  const [confirming, setConfirming] = useState(false)
  const alerts = chat.kind === 'alerts'
  const badge = !active && (chat.kind === 'group' || alerts) && (chat.unreadMentions > 0 || chat.unread > 0)
    ? (chat.unreadMentions > 0 ? { text: `@${chat.unreadMentions}`, label: `${chat.unreadMentions} mentions you` } : { text: chat.unread, label: `${chat.unread} unread` })
    : null
  if (confirming) {
    return (
      <div className="artemis-history-row artemis-history-confirm" role="group" aria-label={`Delete ${chat.title}`}>
        <span className="artemis-flex">{leaves ? 'Leave this session?' : chat.kind === 'group' ? 'Delete for everyone?' : 'Delete this chat?'}</span>
        <button type="button" className="artemis-small-button" onClick={() => setConfirming(false)}>Cancel</button>
        <button type="button" className="artemis-small-button artemis-small-button-danger" onClick={() => onDelete(chat.id)}>{leaves ? 'Leave' : 'Delete'}</button>
      </div>
    )
  }
  return (
    <div className={`artemis-history-item ${active ? 'artemis-history-item-on' : ''}`}>
      <button type="button" className="artemis-history-row" aria-current={active || undefined} onClick={() => onOpen(chat.id)}>
        <span className="artemis-history-line">
          {chat.kind === 'group' && <span className="artemis-shared-icon" title="Shared session"><Icon name="chat" size={13} /></span>}
          {alerts && <span className="artemis-shared-icon artemis-alerts-icon" title="Your alerts"><Icon name="bell" size={13} /></span>}
          <span className="artemis-history-title">{chat.title}</span>
          <span className="artemis-history-time">{chat.time}</span>
        </span>
        {/* Unread counts only mean something in a shared session and the alerts inbox: in a personal chat
            every Artemis reply counts as unread to the server, though the user watched it arrive. */}
        {(chat.preview || badge) && (
          <span className="artemis-history-line artemis-history-line-sub">
            <span className="artemis-history-snippet">{chat.preview}</span>
            {badge && <span className={`artemis-unread ${chat.unreadMentions > 0 ? 'artemis-unread-mention' : ''}`} aria-label={badge.label}>{badge.text}</span>}
          </span>
        )}
      </button>
      {(onArchive || onDelete) && !alerts && (
        <span className="artemis-history-actions">
          {onArchive && (
            <button type="button" className="artemis-icon-button artemis-icon-button-sm artemis-history-archive" title="Archive"
              aria-label={`Archive ${chat.title}`} onClick={() => onArchive(chat.id)}>
              <Icon name="archive" size={15} />
            </button>
          )}
          {onDelete && (
            <button type="button" className="artemis-icon-button artemis-icon-button-sm artemis-history-delete" title={leaves ? 'Leave session' : 'Delete chat'}
              aria-label={`${leaves ? 'Leave' : 'Delete'} ${chat.title}`} onClick={() => setConfirming(true)}>
              <Icon name={leaves ? 'leave' : 'trash'} size={15} />
            </button>
          )}
        </span>
      )}
    </div>
  )
}

// History: a search box, then chats under Today, Yesterday, Previous 7 days and Earlier. Search
// covers the chats loaded so far; Show more loads older ones.
export const PastChats = ({ chats, onOpen, onDelete, onArchive, saved, state, hasMore, onMore }) => {
  const [query, setQuery] = useState('')
  const pinned = chats.filter(isAlertsChat)
  const groups = groupChats(matchChats(chats.filter(c => !isAlertsChat(c)), query))
  return (
    <div className="artemis-history">
      <label className="artemis-history-search">
        <Icon name="find" size={16} />
        <input type="search" value={query} onChange={e => setQuery(e.target.value)} placeholder="Search conversations" aria-label="Search conversations" />
      </label>
      {saved && state === 'failed' && <p className="artemis-muted" role="status">Couldn’t load your chats. <button type="button" className="artemis-link-button" onClick={() => onMore(false)}>Try again</button></p>}
      {chats.length === 0
        ? (state === 'loading'
          ? <p className="artemis-muted" role="status">Loading your chats…</p>
          : state !== 'failed' && <p className="artemis-muted">{saved ? 'Your chats with Artemis show up here.' : 'Chats from this visit show up here.'}</p>)
        : groups.length === 0
          ? <p className="artemis-muted artemis-history-empty">No conversations match.</p>
          : [
            !query && pinned.length > 0 && (
              <div key="alerts" className="artemis-history-group artemis-history-pinned">
                {pinned.map(chat => <HistoryRow key={chat.id} chat={chat} onOpen={onOpen} onDelete={onDelete} onArchive={onArchive} />)}
              </div>
            ),
            ...groups.map(group => (
            <div key={group.label} className="artemis-history-group">
              <span className="artemis-eyebrow artemis-history-label">{group.label}</span>
              {group.chats.map(chat => <HistoryRow key={chat.id} chat={chat} onOpen={onOpen} onDelete={onDelete} onArchive={onArchive} />)}
            </div>
          ))]}
      {hasMore && (
        <button type="button" className="artemis-small-button artemis-load-more" disabled={state === 'loading'} onClick={() => onMore(true)}>
          {state === 'loading' ? 'Loading…' : 'Show more'}
        </button>
      )}
    </div>
  )
}

export const Chatbox = (props) => {
  // Adding and managing skills is for the full-screen Artemis view, not the map and Hunt Planner
  // side panel.
  const manageSkills = !!props.manageSkills
  // 'map' (the map tab's side panel) or 'planner' (Hunt Planner's guided intake).
  const planner = props.surface === 'planner'
  // 'full': the ARTEMIS tab, with sessions beside the chat instead of a history screen.
  const full = props.surface === 'full'
  // Narrow windows (under 900 px) keep the right column behind a button; this opens it.
  const [rightOpen, setRightOpen] = useState(false)
  const [scratchOpen, setScratchOpen] = useState(true)
  const [scratchExpanded, setScratchExpanded] = useState(false)
  // While the full view's scratchpad map is open, Artemis reads that map (its view, basemap and
  // layers) instead of the main map, so questions are about what the user is looking at.
  const [scratchMapObj, setScratchMapObj] = useState(null)
  const [questionString, setQuestionString] = useState('')
  const chatContainerRef = useRef(null)
  const [chatDataRes, dispatchChat] = useReducer(chatReducer, undefined, currentChat)
  const chatRef = useRef(chatDataRes)
  // One controller per in-flight reply, so closing the panel stops them all.
  const streamControllers = useRef(new Map())
  // Set when a question is sent or a chat is opened: the next render jumps to the end once. A reply
  // coming in never moves the panel, so the user stays wherever they've scrolled.
  const scrollToEnd = useRef(true)
  const [view, setView] = useState('chat')
  const [now, setNow] = useState(Date.now())
  const [toast, setToast] = useState(null)
  const toastTimer = useRef(null)
  const [viewTick, setViewTick] = useState(0)
  const [models, setModels] = useState([])
  const [selectedModel, setSelectedModel] = useState(null)
  const conversationRef = useRef(currentConversationId())
  // The open conversation's id as state too, so the scratchpad reloads when it changes.
  const [openConversationId, setOpenConversationIdState] = useState(conversationRef.current)
  const setConversation = id => { conversationRef.current = id; setOpenConversationIdState(id) }

  const savedApi = useMemo(() => ({
    fetchConversations: props.fetchArtemisConversations,
    fetchMessages: props.fetchArtemisConversationMessages,
    deleteConversation: props.deleteArtemisConversation,
    pollMessages: props.pollArtemisMessages
  }), [])
  const saved = useSavedChats(savedApi)
  const openRowState = openConversationId ? saved.rows.find(r => r.id === openConversationId) : null

  // The hub (WEB-7168): the ARTEMIS tab's rail of Chats, Sessions, Alerts and Skills. A session is a
  // conversation with the scratchpad on (lib/artemis/hub); opened holds the ones opened as a session here.
  const hub = full && ARTEMIS_CONVERSATIONS_ENABLED
  const [section, setSection] = useState(() => (hub && takeRequestedSection()) || 'chats')
  const [opened, setOpened] = useState(readOpenedSessions)
  // The conversation each of Chats and Sessions had open, to come back to.
  const lastIn = useRef({})
  // Open as session's note in the thread: { id, after } (after that many turns).
  const [promoted, setPromoted] = useState(null)
  // The scratchpad is on for a session, and for a new conversation started under Sessions.
  const scratchpadOn = hub && (openConversationId ? isSession(openRowState, opened) : section === 'sessions')
  const scratchApi = useMemo(() => ({
    fetch: props.fetchArtemisScratch, add: props.addArtemisScratchItem, update: props.updateArtemisScratchItem,
    remove: props.deleteArtemisScratchItem, send: props.sendArtemisScratch
  }), [])
  const scratch = useScratchpad(scratchApi, scratchpadOn ? openConversationId : null)
  const seesScratch = scratchpadOn && scratchOpen && !!scratchMapObj
  const viewMap = seesScratch ? scratchMapObj : props.mapReference
  // v3: Cancel needs the reply's id, which arrives in its "message" event; a Stop before then waits for it.
  const pendingCancel = useRef(new Set())
  // The open object ids the user dropped from the composer, so they aren't sent.
  const [droppedSelection, setDroppedSelection] = useState(null)
  // The card whose result is drawn on the map, if any.
  const [overlayKey, setOverlayKey] = useState(null)
  // The view's name (API-3644): looked up when the map settles, and taken from each reply's metadata.
  const [mapView, setMapView] = useState(null)
  // Talking to Artemis (WEB-7116): dictation fills the box; read aloud speaks replies.
  const dictatedRef = useRef(false)
  const onDictated = useCallback(text => { dictatedRef.current = true; setQuestionString(text) }, [])
  // Artemis's own speech to text (API-3691) where the server has it; the browser's recogniser as
  // a fallback where it doesn't (a 404 from Transcribe).
  const [serverTranscription, setServerTranscription] = useState(TRANSCRIBE.available)
  const transcribe = useCallback(wav => props.transcribeArtemisAudio(wav, transcriptionContext()), [viewMap, props.user, props.states])
  const onTranscribeUnavailable = useCallback(() => { TRANSCRIBE.available = false; setServerTranscription(false) }, [])
  const serverDictation = useServerDictation(onDictated, transcribe, onTranscribeUnavailable)
  const browserDictation = useDictation(onDictated)
  const dictationHook = serverTranscription && serverDictation.supported ? serverDictation : browserDictation
  const speakerApi = useMemo(() => ({ speak: props.speakArtemisText, voices: props.fetchArtemisVoices }), [])
  const speaker = useSpeaker(speakerApi)
  const [voiceMenuOpen, setVoiceMenuOpen] = useState(false)
  const closeVoiceMenu = useCallback(() => setVoiceMenuOpen(false), [])

  // The user's own skills (WEB-7124, API-3688), and the skill being edited (null: adding one).
  const skillsApi = useMemo(() => ({
    list: props.fetchArtemisSkills, create: props.createArtemisSkill, update: props.updateArtemisSkill, remove: props.deleteArtemisSkill
  }), [])
  const userSkills = useUserSkills(skillsApi)
  const [editingSkill, setEditingSkill] = useState(null)
  const [builtInSkills, setBuiltInSkills] = useState([])
  // The hub's Skills section (WEB-7170): the skill in the editor ({ id } or a new one's { draft }), when
  // each was last saved (for "Rewriting…"), the method a chip opened, the one being copied, and the chat to
  // go back to when a card or chip opened the section.
  const [skillPick, setSkillPick] = useState(null)
  const [skillSavedAt, setSkillSavedAt] = useState({})
  const [methodFocus, setMethodFocus] = useState(null)
  const [makingMine, setMakingMine] = useState(null)
  const skillsReturn = useRef(null)
  const [skillsNotice, setSkillsNotice] = useState(null)
  const skillsReturnView = useRef('chat')

  // Artemis alerts (WEB-7145): the settings screen's data, and whether this server has alerts at all.
  const alertsApi = useMemo(() => (ARTEMIS_CONVERSATIONS_ENABLED ? {
    list: props.fetchArtemisAlerts, update: props.updateArtemisAlert, remove: props.deleteArtemisAlert,
    settings: props.fetchArtemisAlertSettings, saveSettings: props.saveArtemisAlertSettings
  } : NO_ALERTS), [])
  const alerts = useAlerts(alertsApi)
  // The alert the settings screen scrolls to, and the alert message an alert link opened.
  const [alertFocus, setAlertFocus] = useState(null)
  // The hub's Alerts section (WEB-7169): the alert message shown, the list's filter, the messages read
  // here (the server keeps one read mark, so these stay unread to it until the older ones are read), and
  // the questions asked from an alert's page this visit (turn id → its message id).
  const [selectedAlert, setSelectedAlert] = useState(null)
  const [alertFilter, setAlertFilter] = useState('inbox')
  const [alertReadIds, setAlertReadIds] = useState(() => new Set())
  const readPosted = useRef(null)
  const [highlightId, setHighlightId] = useState(null)
  const pendingScroll = useRef(null)
  // Bumped to scroll to pendingScroll in the chat that's already open.
  const [scrollTick, setScrollTick] = useState(0)
  const focusMessage = id => { pendingScroll.current = { id, tries: 0 }; setScrollTick(t => t + 1) }

  // Group chats (full view): who's in the open session, and whether it's shared. A direct chat becomes
  // a group when a partner joins. Partners' messages are polled; Artemis answers only on @Artemis.
  const meId = props.user ? props.user.id : null

  // This month's Artemis allowance (API-3797): a notice over the box from 80%, and the full view's meter.
  // Unlimited users (AllowanceUsd null, as in Production) see neither.
  const usageOn = ARTEMIS_AGENT_ENABLED
  const [usage, setUsage] = useState(null)
  // From the last 429 (API-3800): GET Usage doesn't carry it.
  const [buyCreditsUrl, setBuyCreditsUrl] = useState(null)
  const [usageMenuOpen, setUsageMenuOpen] = useState(false)
  const usageNow = usageState(usage)
  // The usage notice the user closed (warn or credits), until its kind or the month changes.
  const [dismissedUsageNotice, setDismissedUsageNotice] = useState(dismissedNotice)
  // Credits can be bought at any time where they're sold, which is wherever there's an allowance.
  const buyUrl = buyCreditsUrl || (usageNow.metered ? CREDITS_PAGE : null)
  const loadUsage = () => props.fetchArtemisUsage().then(u => setUsage(u || null)).catch(() => {})
  useEffect(() => { if (usageOn) loadUsage() }, [])
  const [members, setMembers] = useState([])
  // Who else in the group is typing, from the last poll ([{ UserId, Name }]).
  const [typing, setTyping] = useState([])
  // Set while a question is being sent, so clearing the box for it doesn't also send a DELETE Typing.
  const sendingRef = useRef(false)
  const [inviteOpen, setInviteOpen] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const [membersOpen, setMembersOpen] = useState(false)
  // Start a session: the next chat opens with the invite sheet up.
  const inviteNext = useRef(false)
  // The alerts inbox is open: no invites, renames or deletes there (the server refuses them).
  const inAlerts = !!openConversationId && (isAlertsChat(openRowState) || openConversationId === alerts.conversationId)
  const group = full && ARTEMIS_CONVERSATIONS_ENABLED && !!openConversationId && (members.length > 1 || isGroup(openRowState))
  const mentionOpts = useMemo(() => (group ? mentionOptions(members, meId) : null), [group, members, meId])
  const loadMembers = id => props.fetchArtemisMembers(id).then(r => setMembers((r && r.Items) || [])).catch(() => {})
  const membersRef = useRef(members)
  membersRef.current = members
  useEffect(() => {
    setInviteOpen(inviteNext.current)
    inviteNext.current = false
    setMenuOpen(false)
    setMembersOpen(false)
    if (!full || !ARTEMIS_CONVERSATIONS_ENABLED || !openConversationId) { setMembers([]); return }
    loadMembers(openConversationId)
  }, [openConversationId])

  // Someone joined or left while the chat is open: the sessions list (refreshed every 30 s) has a new
  // member count, so reload the header's members. A chat that just became a group starts polling then.
  const rowMemberCount = openRowState && Array.isArray(openRowState.members) ? openRowState.members.length : 0
  useEffect(() => {
    if (full && ARTEMIS_CONVERSATIONS_ENABLED && openConversationId && rowMemberCount && rowMemberCount !== membersRef.current.length) loadMembers(openConversationId)
  }, [rowMemberCount, openConversationId])

  useEffect(() => {
    if (!group || !openConversationId) return
    let stopped = false, timer = null
    const id = openConversationId
    const next = () => { if (!stopped) timer = setTimeout(tick, document.hidden ? 30000 : 4000) }
    const tick = () => {
      // Not while this user's own reply streams: its turn takes the server's ids when it ends.
      if (streamControllers.current.size > 0) return next()
      saved.poll(id)
        .then(result => {
          if (stopped || !result) return
          setTyping(result.typing || [])
          if (!result.turns) return
          dispatchChat({ type: 'reset', messages: mergePolled(chatRef.current, result.turns) })
          // A message from someone the header doesn't know yet: they just joined.
          const known = new Set(membersRef.current.map(m => String(m.UserId)))
          if (result.turns.some(t => t.authorUserId != null && !known.has(String(t.authorUserId)))) loadMembers(id)
          if (!document.hidden) props.markArtemisRead(id, result.lastSeq).catch(() => {})
          // A partner's question may have put drafts on the shared scratchpad: they reach the asker's
          // panel through its stream, everyone else's through here.
          if (scratchpadOn) scratchRef.current.load()
        })
        .catch(() => {})
        .finally(next)
    }
    next()
    return () => { stopped = true; clearTimeout(timer); setTyping([]) }
  }, [group, openConversationId])

  // This user's typing, for the others in a group: a POST at most every TYPING_EVERY_MS while the box
  // has text, and a DELETE when they clear it. Sending the message stops it on the server.
  const typingSentAt = useRef(0)
  useEffect(() => {
    if (!group || !openConversationId) return
    const hasText = !!questionString.trim()
    const now = Date.now()
    if (hasText) {
      sendingRef.current = false
      if (now - typingSentAt.current >= TYPING_EVERY_MS) {
        typingSentAt.current = now
        props.setArtemisTyping(openConversationId, true).catch(() => {})
      }
    } else if (typingSentAt.current) {
      typingSentAt.current = 0
      if (sendingRef.current) sendingRef.current = false
      else props.setArtemisTyping(openConversationId, false).catch(() => {})
    }
  }, [questionString, group, openConversationId])
  useEffect(() => { typingSentAt.current = 0 }, [openConversationId])

  // An invite link (landing page keeps its token): join, then open the session.
  useEffect(() => {
    if (!full || !ARTEMIS_CONVERSATIONS_ENABLED) return
    let token = null
    try { token = window.sessionStorage.getItem('artemis.invite'); window.sessionStorage.removeItem('artemis.invite') } catch (e) { /* no storage */ }
    if (!token) return
    props.acceptArtemisInvite(token)
      .then(conversation => {
        showToast({ text: `You joined ${conversation.Title || 'the session'}` })
        saved.loadList()
        openChat(conversation.Id, { group: true })
      })
      .catch(err => showToast({ text: err && err.code === 'invite_expired' ? 'This invite link has expired. Ask for a new one.' : (err && err.userMessage) || 'Couldn’t join that session' }))
  }, [])

  // An alert link (/artemis?conversation=ID&message=ID, from an alert email, push or text, or an @mention
  // push; the landing page keeps it): open that conversation at that message.
  useEffect(() => {
    if (!full || !ARTEMIS_CONVERSATIONS_ENABLED) return
    let link = null
    try { link = JSON.parse(window.sessionStorage.getItem('artemis.open') || 'null'); window.sessionStorage.removeItem('artemis.open') } catch (e) { /* no storage */ }
    if (!link || !link.conversation) return
    openChat(link.conversation, { message: link.message || null })
  }, [])

  // Shared scratchpad: also refreshed every 20 s while the session is open, for drafts and pins
  // partners add without a new message.
  const scratchRef = useRef(scratch)
  scratchRef.current = scratch
  useEffect(() => {
    if (!group || !scratchpadOn || !openConversationId) return undefined
    const timer = setInterval(() => { if (!document.hidden && streamControllers.current.size === 0) scratchRef.current.load() }, 20000)
    return () => clearInterval(timer)
  }, [group, scratchpadOn, openConversationId])

  // The sessions list refreshes its unread and @ badges every 30 s in the full view.
  useEffect(() => {
    if (!full || !ARTEMIS_CONVERSATIONS_ENABLED) return
    const timer = setInterval(() => { if (!document.hidden) saved.loadList() }, 30000)
    return () => clearInterval(timer)
  }, [])

  const hasPro = userHasPro(props.user)
  const working = chatDataRes.some(m => m.status === 'streaming')
  // The turn shown in full: the newest one Artemis answered (or is answering). In a group, partners'
  // messages that didn't mention Artemis come after it without folding it away.
  const latestReplyIndex = (() => {
    for (let i = chatDataRes.length - 1; i >= 0; i--) if (chatDataRes[i].status !== 'posted' && chatDataRes[i].kind !== 'alert') return i
    return chatDataRes.length - 1
  })()

  // Reads the latest reply aloud as it arrives (WEB-7123): short progress callouts while it runs,
  // then the whole answer sentence by sentence, or the server's short summary. Only replies asked
  // with read aloud on; turning it off mid-reply keeps the rest of that reply quiet.
  const latestMessage = chatDataRes[chatDataRes.length - 1]
  useEffect(() => {
    if (!ARTEMIS_AGENT_ENABLED || !latestMessage || !latestMessage.readAloud) return
    const read = READ.get(latestMessage.id) || { plan: undefined, muted: false }
    if (!speaker.enabled) { READ.set(latestMessage.id, { ...read, muted: true }); return }
    if (read.muted) return
    const { progress, answer, plan } = nextSpeech(latestMessage, speaker.mode, read.plan)
    READ.set(latestMessage.id, { ...read, plan })
    progress.forEach(line => speaker.progress(line))
    answer.forEach(text => speaker.say(text))
  }, [latestMessage, speaker.enabled, speaker.mode])

  // Stops reading, and keeps the latest reply quiet however much more of it arrives.
  const silence = () => {
    const latest = chatRef.current[chatRef.current.length - 1]
    if (latest) READ.set(latest.id, { ...(READ.get(latest.id) || {}), muted: true })
    speaker.stop()
  }

  // The waypoint or shape open on the map, offered as what the question is about (API-3642).
  const openObject = ARTEMIS_AGENT_ENABLED ? selectionFor(props.selectedObjId, props) : null
  const about = openObject && droppedSelection !== props.selectedObjId ? openObject : null

  useEffect(() => {
    if (ARTEMIS_CONVERSATIONS_ENABLED) saved.loadList()
  }, [])

  // The rail's and the ARTEMIS tab's badges follow whichever panel loaded the list last.
  useEffect(() => {
    if (ARTEMIS_CONVERSATIONS_ENABLED && saved.listState === 'loaded') badgeStore.set(currentBadges())
  }, [saved.rows, saved.listState, alertReadIds, chatDataRes])

  // The tab reopening on the conversation it had: the section it belongs in, once the list says which.
  const placedOnce = useRef(false)
  useEffect(() => {
    if (!hub || placedOnce.current || saved.listState !== 'loaded') return
    placedOnce.current = true
    if (openRowState && section === 'chats') setSection(sectionFor(openRowState, opened))
  }, [saved.listState])

  // Chats and Sessions each come back to the conversation they last had open.
  useEffect(() => {
    if (!hub || !openConversationId) return
    const at = sectionFor(openRowState || { id: openConversationId }, opened)
    if (at === 'chats' || at === 'sessions') lastIn.current[at] = openConversationId
  }, [openConversationId, opened, !!openRowState])

  // Names the view before the first question, and again whenever the map settles after a move.
  useEffect(() => {
    const map = viewMap
    if (!ARTEMIS_AGENT_ENABLED || !map) return undefined
    let latest = 0, timer = null
    const lookUp = () => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        const context = mapContext(map)
        if (!context) return
        const ask = ++latest
        const [lng, lat] = context.MapCenter
        // 503 view_unavailable means the lookup was slow or failed: retry once. After that, or on any
        // other failure, drop the name rather than keep the last place's.
        const attempt = retried => props.fetchArtemisView(lat, lng)
          .then(view => { if (ask === latest) setMapView(normalizeView(view)) })
          .catch(err => {
            if (ask !== latest) return
            if (!retried && err && err.code === 'http_503') timer = setTimeout(() => attempt(true), VIEW_RETRY_MS)
            else setMapView(null)
          })
        attempt(false)
      }, VIEW_LOOKUP_DEBOUNCE_MS)
    }
    lookUp()
    const googleMaps = window.google && window.google.maps
    let listener = null
    if (googleMaps && map instanceof googleMaps.Map) listener = googleMaps.event.addListener(map, 'idle', lookUp)
    else if (map.on) map.on('moveend', lookUp)
    return () => {
      clearTimeout(timer)
      latest = -1
      if (listener) googleMaps.event.removeListener(listener)
      else if (map.off) map.off('moveend', lookUp)
    }
  }, [viewMap])

  // The chat outlives the panel: it goes back to the session store on every change.
  useEffect(() => {
    chatRef.current = chatDataRes
    setCurrentChat(chatDataRes)
  }, [chatDataRes])

  useEffect(() => () => {
    const latest = chatRef.current[chatRef.current.length - 1]
    if (latest) READ.set(latest.id, { ...(READ.get(latest.id) || {}), muted: true })
    streamControllers.current.forEach(controller => controller.abort())
    streamControllers.current.clear()
    const at = Date.now()
    // A v3 reply keeps being written and saved after the panel closes; reopening the chat shows it.
    const unfinished = ARTEMIS_CONVERSATIONS_ENABLED ? 'saving' : 'stopped'
    setCurrentChat(chatRef.current.map(m => m.status === 'streaming' ? { ...m, status: unfinished, endedAt: at } : m))
    setCurrentConversationId(conversationRef.current)
    // A drawn result goes with the panel, since its Hide button does.
    props.clearArtemisOverlay()
    clearTimeout(toastTimer.current)
  }, [])

  // Keeps the elapsed labels moving while a reply runs, here or (polled) a partner's.
  const ticking = working || chatDataRes.some(m => m.status === 'saving')
  useEffect(() => {
    if (!ticking) { setNow(Date.now()); return }
    const timer = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(timer)
  }, [ticking])

  useEffect(() => {
    const container = chatContainerRef.current
    if (!container || chatDataRes.length === 0) return
    const target = pendingScroll.current
    if (target) {
      const el = container.querySelector(`[data-message-id="${CSS.escape(String(target.id))}"]`)
      if (el) {
        pendingScroll.current = null
        scrollToEnd.current = false
        el.scrollIntoView({ block: 'center' })
        setHighlightId(target.id)
        return
      }
      // Not on the first page: look a few pages further back, then settle for the end.
      if (saved.hasEarlier && !saved.loadingEarlier && target.tries < 5) {
        target.tries += 1
        loadEarlier()
        return
      }
      if (!saved.loadingEarlier) pendingScroll.current = null
    }
    if (!scrollToEnd.current) return
    container.scrollTop = container.scrollHeight
    scrollToEnd.current = false
  }, [chatDataRes, view, scrollTick])

  // What Transcribe gets to correct unit names against: the map view and home state.
  const transcriptionContext = () => {
    let context = mapContext(viewMap) || null
    const homeState = homeStateCode(props.user, props.states)
    if (homeState) context = { ...(context || {}), HomeState: homeState }
    return context
  }

  useEffect(() => {
    if (__NODE_ENV__ !== 'production') {
      props.fetchArtemisModels()
        .then(result => {
          const list = result || []
          setModels(list)
          if (list.length > 0) setSelectedModel(list[0].key)
        })
        .catch(() => {})
    }
  }, [])

  const showToast = useCallback(next => {
    clearTimeout(toastTimer.current)
    setToast(next)
    toastTimer.current = setTimeout(() => setToast(null), TOAST_MS)
  }, [])

  // The scratchpad map's own layers and moves (full view). The main map is hidden on the ARTEMIS tab,
  // so there Artemis's set_layer_visibility and set_map_view, their Undo, and Apply on a partner's
  // changes act on the scratchpad map instead. Its layers start as a copy of the main map's and are
  // kept per conversation in this browser.
  const scratchMapOn = full && scratchpadOn
  const [scratchLayers, setScratchLayersState] = useState(() => initialScratchLayers(props.activeLayers, props.layersDictionary))
  const scratchLayersRef = useRef(scratchLayers)
  const scratchMapRef = useRef(null)
  const [scratchView, setScratchView] = useState(null)
  const layersConversation = useRef(openConversationId)
  const setScratchLayers = next => {
    scratchLayersRef.current = next
    setScratchLayersState(next)
    writeScratchLayers(conversationRef.current, next)
  }
  useEffect(() => {
    if (!scratchMapOn) return
    const was = layersConversation.current
    layersConversation.current = openConversationId
    // A new chat just got its id: keep what it had, under the id.
    if (!was && openConversationId && !readScratchLayers(openConversationId)) return writeScratchLayers(openConversationId, scratchLayersRef.current)
    const next = readScratchLayers(openConversationId) || initialScratchLayers(props.activeLayers, props.layersDictionary)
    scratchLayersRef.current = next
    setScratchLayersState(next)
  }, [openConversationId])

  const layerRules = { layersDictionary: props.layersDictionary, userSubscriptions: (props.user && props.user.userSubscription) || [], productionLayers: props.productionLayers }
  // set_layer_visibility on the scratchpad map: the main map's result shape ({ outcome, layerId, ... }).
  const setScratchLayer = input => {
    const { next, ...result } = requestScratchLayer(scratchLayersRef.current, input, layerRules)
    if (next) { setScratchLayers(next); setScratchOpen(true) }
    return result
  }
  // set_map_view on the scratchpad map: { outcome, label, view, previous }.
  const moveScratchMap = input => {
    const label = (input && typeof input.label === 'string' && input.label.trim()) || null
    const view = viewFromInput(input)
    if (!view) return { outcome: 'invalid_input', label, view: null, previous: null }
    const previous = readMapView(scratchMapRef.current)
    setScratchOpen(true)
    setScratchView(v => ({ n: ((v && v.n) || 0) + 1, view }))
    return { outcome: 'moved', label, view, previous }
  }
  // A client action from the stream, run where this view shows the map.
  const runClientAction = event => {
    if (scratchMapOn && event.Type === 'action' && event.Tool === 'set_layer_visibility') {
      return Promise.resolve({ toolUseId: event.ToolUseId, tool: event.Tool, ...setScratchLayer(event.Input) })
    }
    if (scratchMapOn && event.Type === 'action' && event.Tool === 'set_map_view') {
      return Promise.resolve({ toolUseId: event.ToolUseId, tool: event.Tool, ...moveScratchMap(event.Input) })
    }
    return props.handleArtemisAgentEvent(event)
  }
  // Apply on a change Artemis made on someone else's map (or before this page loaded). True when done.
  const applyChange = change => {
    const result = change.tool === 'set_layer_visibility'
      ? (scratchMapOn ? setScratchLayer(change.input) : props.runSetLayerVisibility(change.input))
      : (scratchMapOn ? moveScratchMap(change.input) : props.runSetMapView(change.input))
    if (result.outcome === 'subscription_required') showToast({ text: `${result.layerName} needs a subscription` })
    return result.outcome === 'changed' || result.outcome === 'unchanged' || result.outcome === 'moved'
  }
  const scratchMapProps = scratchMapOn ? {
    // It opens where the user's map is, unless that hasn't been placed yet either.
    startView: props.mapReference && !atStartView(props.mapReference) ? readMapView(props.mapReference) : null,
    layers: scratchLayers,
    layersDictionary: props.layersDictionary,
    filters: props.filters,
    view: scratchView,
    onMap: m => { scratchMapRef.current = m; setScratchMapObj(m) },
    layerChoices: scratchLayerChoices(scratchLayers, props.activeLayers, props.layersDictionary, layerRules.userSubscriptions, props.productionLayers),
    onPickBasemap: id => setScratchLayer({ layer_id: id, visible: true }),
    onToggleOverlay: (id, visible) => setScratchLayer({ layer_id: id, visible })
  } : {}

  // Undo and Redo on a layer change: the same tap Artemis's action made, the other way.
  // A unit alert's "Show on map" (API-3885): its layers go on as a map link's do (through the layer
  // menu's rules, with the upgrade prompt for locked ones) and off one by one.
  const alertLayers = useMemo(() => ({
    active: props.activeLayers,
    show: layerIds => props.applyDeepLinkLayers(layerIds),
    hide: layerIds => layerIds.forEach(id => props.runSetLayerVisibility({ layer_id: id, visible: false }))
  }), [props.activeLayers])

  // A hunt list's "Show in Hunt Planner" (API-3887): the planner picks up the list's state, species
  // and hunt type as it does Artemis's own set_planner_filters, and the planner tab opens.
  const openPlanner = selection => {
    const result = props.runSetPlannerFilters(selection)
    if (result.outcome !== 'applied') {
      // The planner's option lists load when it opens, so before then the picks go on as a planner link's do.
      if ((props.huntplannerStatesData || []).length > 0) {
        showToast({ text: `Hunt Planner doesn't offer ${String(result.field || 'that').replace('_', ' ')} like that` })
        return
      }
      props.huntPlannerActiveOptions({ StateAbbreviation: selection.state, Species: selection.species, HuntTypeKey: selection.hunt_type })
    }
    if (!planner) props.selectTab('huntplanner')
    showToast({ text: `Hunt Planner: ${result.label || `${selection.state} ${selection.species}`}` })
  }

  const toggleLayer = (messageId, action, visible) => {
    const result = scratchMapOn
      ? setScratchLayer({ layer_id: action.layerId, visible, layer_name: action.layerName })
      : props.runSetLayerVisibility({ layer_id: action.layerId, visible, layer_name: action.layerName })
    if (result.outcome === 'changed' || result.outcome === 'unchanged') {
      dispatchChat({ type: 'actionToggled', id: messageId, toolUseId: action.toolUseId, visible })
    } else if (result.outcome === 'subscription_required') {
      showToast({ text: `${action.layerName} needs a subscription` })
    }
  }

  const onShowObject = object => props.showArtemisObject(object.result)

  // A hunt card's "Show on map". In a session it's drawn on the scratchpad's map (opened if it was
  // closed); elsewhere on the main map, which a chat on the ARTEMIS tab offers to go to.
  const [scratchPreview, setScratchPreview] = useState(null)
  const overlay = {
    key: overlayKey,
    show: (key, focus) => {
      if (scratchpadOn) {
        setScratchOpen(true)
        setScratchPreview(focus)
        setOverlayKey(focus ? key : null)
      } else {
        const shown = props.showArtemisOverlay(focus)
        setOverlayKey(shown ? key : null)
        if (shown && full && focus) showToast({ text: 'Shown on your map', button: 'Go to map', run: () => props.selectTab('map') })
      }
    },
    hide: () => { props.clearArtemisOverlay(); setScratchPreview(null); setOverlayKey(null) }
  }

  const onRemoveObject = (message, object) => {
    props.removeArtemisObject(object.result)
      .then(() => {
        dispatchChat({ type: 'objectRemoved', id: message.id, objectKey: object.key })
        showToast({ text: `Removed “${object.name}” from your map` })
      })
      .catch(() => showToast({ text: `Couldn’t remove “${object.name}”. Try again from My Content.` }))
  }

  // Undo and Redo on a map move: back to the view before it, or to Artemis's again.
  const toggleView = (messageId, action, undo) => {
    const view = undo ? action.previous : action.view
    const moved = scratchMapOn
      ? (!!view && (setScratchView(v => ({ n: ((v && v.n) || 0) + 1, view })), true))
      : props.moveArtemisMap(view)
    if (moved) {
      dispatchChat({ type: 'viewToggled', id: messageId, toolUseId: action.toolUseId, undone: undo })
    }
  }

  const onToastAction = () => {
    if (toast && toast.run) toast.run()
    else if (toast && toast.undoView) toggleView(toast.undoView.messageId, toast.undoView.action, true)
    else if (toast && toast.undo) toggleLayer(toast.undo.messageId, toast.undo.action, !toast.undo.action.visible)
    setToast(null)
  }

  const cancelSaved = message => {
    props.cancelArtemisMessage(message.conversationId || conversationRef.current, message.messageId)
      // Not streaming any more (404) or unreachable: stop reading instead.
      .catch(() => { const c = streamControllers.current.get(message.id); if (c) c.abort() })
  }

  // v2: closing the connection stops the reply. v3: the server keeps writing unless it's cancelled,
  // and ends the stream with a cancelled "done".
  const stopAll = () => {
    silence()
    if (!ARTEMIS_CONVERSATIONS_ENABLED) {
      streamControllers.current.forEach(controller => controller.abort())
      return
    }
    chatRef.current.filter(m => m.status === 'streaming').forEach(message => {
      if (message.messageId) cancelSaved(message)
      else pendingCancel.current.add(message.id)
    })
  }

  // Leaves the replies to finish on their own, for switching chats.
  const detachAll = () => {
    streamControllers.current.forEach(controller => controller.abort())
    streamControllers.current.clear()
  }

  const onGetAnswerHandle = async (ques) => {
    const currentQuestion = ques || questionString
    if (!currentQuestion.trim() || working) return
    // Posting stops this user's typing on the server, so no DELETE Typing for the box clearing.
    sendingRef.current = true
    setQuestionString('')
    setView('chat')
    scrollToEnd.current = true

    // Read before this question joins the chat. v3 keeps its own history.
    const history = ARTEMIS_CONVERSATIONS_ENABLED ? [] : chatHistory(chatDataRes)
    let context = mapContext(viewMap, seesScratch
      ? { overlayLayerIds: drawnOverlayIds(scratchLayers, props.layersDictionary), basemapLayerId: scratchLayers.basemapId }
      : {
        overlayLayerIds: visibleOverlayLayerIds(props.activeLayers, props.layersDictionary, props.layersVisible),
        basemapLayerId: activeBasemapLayerId(props.activeLayers, props.layersDictionary)
      })
    if (about) context = { ...(context || {}), Selection: about.selection }
    const homeState = ARTEMIS_AGENT_ENABLED ? homeStateCode(props.user, props.states) : null
    if (homeState) context = { ...(context || {}), HomeState: homeState }
    // How the question was asked and whether the reply will be spoken (API-3690).
    const readAloud = ARTEMIS_AGENT_ENABLED && speaker.enabled
    if (ARTEMIS_AGENT_ENABLED && dictatedRef.current) context = { ...(context || {}), InputMode: 'voice' }
    if (readAloud) context = { ...(context || {}), ReadAloud: true }
    if (planner) context = { ...(context || {}), ...plannerContext(props.huntPlannerSelectedOptions, props.huntplannerStatesData, props.huntplannerMorefiltersState) }
    // The full view keeps Artemis's finds as drafts on the scratchpad instead of saving them.
    if (scratchpadOn) context = { ...(context || {}), Scratchpad: true }
    dictatedRef.current = false
    // While this click or key press counts as one, so the reply's audio isn't blocked.
    if (readAloud) speaker.unlock()
    silence()
    if (dictationHook.listening) dictationHook.stop()

    const id = newMessageId()
    const controller = new AbortController()
    streamControllers.current.set(id, controller)
    dispatchChat({ type: 'asked', id, question: currentQuestion, at: Date.now(), readAloud })

    let queryId = null
    let savedObjects = false
    // A reply that ends with ask_user's questions gets no suggested follow-ups.
    let asked = false
    // Who a group message @mentions; without Artemis it's only posted (no reply). A question picked from
    // Artemis's own UI (its ask card, a follow-up, a starter, Try again) always goes to Artemis; only what's
    // typed in the composer (no ques) needs @Artemis.
    const mentions = group && mentionOpts ? mentionsFromText(currentQuestion, mentionOpts) : []
    if (group && ques && !mentions.includes('artemis')) mentions.push('artemis')
    const options = {
      history,
      context,
      ...(mentions.length && { mentions }),
      ...(planner && { actions: ARTEMIS_PLANNER_ACTIONS }),
      signal: controller.signal,
      onEvent: event => {
        // A skill saved from the chat joins the list (and its card's buttons act on it).
        // Artemis then rewrites it in the background (API-3801): look again once that's likely done.
        if (event.Type === 'step' && event.Status === 'succeeded' && event.Result && event.Result.Kind === 'user_skill') {
          userSkills.refresh()
          userSkills.refreshSoon(event.Result.Id)
        }
        if (event.Type === 'step' && event.Status === 'succeeded' && event.Result && event.Result.Kind === 'ask_user') asked = true
        if (scratchpadOn && event.Type === 'step' && event.Status === 'succeeded') scratch.merge(scratchFromStep(event.Result))
        if (event.Type === 'metadata') {
          queryId = event.QueryId
          if (event.View) setMapView(normalizeView(event.View))
        }
        dispatchChat({ type: 'event', id, event, at: Date.now() })
        if (event.Type === 'message' && pendingCancel.current.delete(id)) {
          cancelSaved({ id, messageId: event.MessageId, conversationId: event.ConversationId })
        }

        if (ARTEMIS_AGENT_ENABLED && (event.Type === 'action' || event.Type === 'tool')) {
          if (event.Type === 'tool' && event.Status === 'succeeded' && isObjectCreatingTool(event.Tool) && !scratchpadOn) {
            savedObjects = true
            showToast({ text: event.Tool === 'create_shape' ? 'Artemis saved a shape to your map' : 'Artemis saved a waypoint to your map' })
          }
          // Client actions run straight away, not after done.
          runClientAction(event)
            .then(result => {
              if (!result) return
              dispatchChat({ type: 'actionResult', id, result })
              if (result.tool === 'set_planner_filters' && result.outcome === 'applied') {
                showToast({ text: `Artemis set up the planner: ${result.label}` })
              } else if (result.tool === 'set_map_view' && result.outcome === 'moved') {
                showToast({
                  text: `Artemis moved the map${result.label ? ` to ${result.label}` : ''}`,
                  button: result.previous ? 'Undo' : null,
                  undoView: { messageId: id, action: result }
                })
              } else if (result.outcome === 'changed') {
                showToast({
                  text: `Artemis turned ${result.visible ? 'on' : 'off'} ${result.layerName}`,
                  button: 'Undo',
                  undo: { messageId: id, action: result }
                })
              }
            })
            .catch(err => console.error('Artemis action failed:', err))
        }
      }
    }

    try {
      const modelKey = __NODE_ENV__ !== 'production' ? selectedModel : null
      let done
      if (ARTEMIS_CONVERSATIONS_ENABLED) {
        if (!conversationRef.current) {
          const conversation = await props.createArtemisConversation({ scratchpad: scratchpadOn })
          // A new conversation under Sessions is a session from its first message.
          if (scratchpadOn) setOpened(o => rememberSession(o, conversation.Id))
          setConversation(conversation.Id)
          setCurrentConversationId(conversation.Id)
        }
        options.clientMessageId = newClientMessageId()
        done = await props.postArtemisConversationMessage(conversationRef.current, currentQuestion, options, modelKey)
      } else {
        done = await props.postArtemisQuestion(currentQuestion, options, modelKey)
      }

      // A group message that didn't mention Artemis comes back as { Message } (the user's own) with no stream.
      const postedMessage = done && done.message && (done.message.Message || done.message)
      if (postedMessage && postedMessage.AuthorType === 'user') {
        saved.addRaw(postedMessage)
        dispatchChat({ type: 'posted', id, messageId: postedMessage.Id, seq: postedMessage.Seq, at: Date.now() })
        if (conversationRef.current) props.markArtemisRead(conversationRef.current, postedMessage.Seq).catch(() => {})
        return done
      }
      // A resent ClientMessageId whose reply was already saved comes back as the Message itself.
      if (done && done.message) {
        const [saved] = messagesFromConversation([
          { AuthorType: 'user', Id: -1, Seq: 0, Text: currentQuestion },
          { ...done.message, ReplyToId: -1 }
        ])
        dispatchChat({ type: 'replaced', id, message: saved })
        queryId = saved.queryId
      }
      props.refreshAfterArtemisReply(savedObjects)
      if (queryId && !asked && !controller.signal.aborted) {
        props.fetchSuggestedQuestions(queryId)
          .then(response => dispatchChat({ type: 'suggestions', id, suggestedQuestions: response }))
          .catch(() => {})
      }
      return done
    } catch (err) {
      props.refreshAfterArtemisReply(savedObjects)
      // A chat deleted elsewhere: the next question starts a new one.
      if (ARTEMIS_CONVERSATIONS_ENABLED && err?.code === 'http_404') setConversation(null)
      if (err?.code === 'usage_limit_reached') {
        // Refused before anything happened (API-3797): nothing was asked, so the turn goes and the text
        // comes back to the box for after the reset; the notice over the box says when.
        dispatchChat({ type: 'removed', id })
        setQuestionString(current => current || currentQuestion)
        setUsage(err.usage || { AllowanceUsd: 1, PercentUsed: 100, LimitReached: true, ResetsAt: err.resetsAt })
        setBuyCreditsUrl(err.buyCreditsUrl || null)
        return
      }
      dispatchChat(isAbortError(err) ? { type: 'stopped', id, at: Date.now() } : { type: 'failed', id, code: err?.code, at: Date.now() })
    } finally {
      streamControllers.current.delete(id)
      pendingCancel.current.delete(id)
      if (usageOn) loadUsage()
    }
  }

  // Keyed to the saved reply on v3, and to the QueryId on v2.
  const savedReply = message => ARTEMIS_CONVERSATIONS_ENABLED && message.messageId
    ? [message.conversationId || conversationRef.current, message.messageId]
    : null

  const onFeedback = (message, useful) => {
    const reply = savedReply(message)
    const sent = reply
      ? props.artemisMessageFeedback(reply[0], reply[1], { Useful: useful }).then(() => ({ useful }))
      : props.feedbackOnAnswer({ queryId: message.queryId, useful })
    sent
      .then(res => dispatchChat({ type: 'feedback', id: message.id, useful: res.useful }))
      .catch(err => console.error('Error Response:', err))
  }

  const onFeedbackComment = (message, comment) => {
    const reply = savedReply(message)
    return reply
      ? props.artemisMessageFeedback(reply[0], reply[1], { Comment: comment })
      : props.feedbackCommentOnAnswer({ queryId: message.queryId, comment })
  }

  // The API takes useful=false to flag a source and useful=true to take it back.
  const onSourceFeedback = (message, source, useful) => {
    props.dislikeOnSuggestionQuestion({ queryId: message.queryId, documentId: source.documentId, useful })
      .then(res => dispatchChat({ type: 'sourceFeedback', id: message.id, documentId: res.documentId, disliked: !res.useful }))
      .catch(err => console.error('Error Response:', err))
  }

  const onCopy = message => {
    const text = answerToText(message.answer)
    const copied = navigator.clipboard && navigator.clipboard.writeText ? navigator.clipboard.writeText(text) : Promise.reject()
    copied.then(() => showToast({ text: 'Answer copied' })).catch(() => {})
  }

  // Pin to scratchpad (full view): the answer as a note, titled with its opening words.
  const onPin = message => {
    const text = answerToText(message.answer).trim()
    if (!text) return
    const title = text.length > 70 ? `${text.slice(0, 68).trim()}…` : text
    scratch.add({ Kind: 'note', Title: title, Data: { Text: text.slice(0, 4000) }, MessageId: message.messageId || null })
      .then(() => { setScratchOpen(true); showToast({ text: 'Pinned to the scratchpad' }) })
      .catch(err => showToast({ text: (err && err.code === 'scratchpad_full') ? 'The scratchpad is full' : 'Couldn’t pin that answer' }))
  }

  const loadBuiltIns = () => {
    if (builtInSkills.length) return
    props.fetchArtemisBuiltInSkills()
      .then(list => setBuiltInSkills(Array.isArray(list) ? list : (list && list.Items) || []))
      .catch(() => {})
  }
  // In the hub: the Skills section with that skill (or a new one) in the editor, and a way back to the
  // chat it was opened from.
  const openSkill = (skill, method = null) => {
    skillsReturn.current = (section === 'chats' || section === 'sessions') && conversationRef.current
      ? { id: conversationRef.current } : skillsReturn.current
    setSkillsNotice(null)
    setMethodFocus(method)
    if (!method) setSkillPick(skill ? { id: skill.Id } : { draft: emptySkillForm(), n: Date.now() })
    loadBuiltIns()
    setRightOpen(false)
    setSection('skills')
    setView('skills')
  }
  const openSkillForm = skill => {
    if (hub) return openSkill(skill)
    if (view !== 'skill-form') skillsReturnView.current = view
    setEditingSkill(skill || null)
    setSkillsNotice(null)
    if (!skill && builtInSkills.length === 0) {
      props.fetchArtemisBuiltInSkills()
        .then(list => setBuiltInSkills(Array.isArray(list) ? list : (list && list.Items) || []))
        .catch(() => {})
    }
    setView('skill-form')
    if (hub) setSection('skills')
  }
  const closeSkillForm = () => setView(hub ? 'skills' : skillsReturnView.current)

  const saveSkill = payload => (editingSkill ? userSkills.update(editingSkill.Id, payload) : userSkills.create(payload))
    .then(() => {
      showToast({ text: editingSkill ? 'Skill saved' : 'Skill added. Artemis will use it when a question fits.' })
      closeSkillForm()
    })

  const toggleSkill = (skill, on) => {
    setSkillsNotice(null)
    userSkills.update(skill.Id, { Enabled: on })
      .then(() => showToast({ text: on ? `Turned on “${skill.Title}”` : `Turned off “${skill.Title}”` }))
      .catch(err => { const text = (err && err.userMessage) || 'Couldn’t change that skill. Try again.'; setSkillsNotice(text); showToast({ text }) })
  }

  // The hub's editor: a new skill is created and then shown as itself; Body or AppliesWhen changes start
  // Artemis's rewrite, so "Rewriting…" shows for a while.
  const saveHubSkill = (skill, payload) => (skill ? userSkills.update(skill.Id, payload) : userSkills.create(payload))
    .then(saved => {
      const id = skill ? skill.Id : saved && saved.Id
      if (id != null && startsRewrite(payload, skill)) setSkillSavedAt(t => ({ ...t, [id]: Date.now() }))
      if (!skill && id != null) setSkillPick({ id })
      showToast({ text: skill ? 'Skill saved' : 'Skill added. Artemis will use it when a question fits.' })
    })
  const makeMine = builtIn => {
    setMakingMine(builtIn.Name)
    props.fetchArtemisBuiltInSkill(builtIn.Name)
      .then(full => setSkillPick({ draft: draftFromBuiltIn({ ...builtIn, ...(full || {}) }), n: Date.now() }))
      .catch(() => showToast({ text: 'Couldn’t open that method. Try again.' }))
      .finally(() => setMakingMine(null))
  }

  const deleteSkill = skill => {
    userSkills.remove(skill.Id)
      .then(() => { if (skillPick && skillPick.id === skill.Id) setSkillPick(null); showToast({ text: `Deleted “${skill.Title}”` }) })
      .catch(err => showToast({ text: (err && err.userMessage) || 'Couldn’t delete that skill. Try again.' }))
  }

  // For the chat's saved-skill cards: the skill as it stands now; null once deleted, undefined
  // while the list hasn't loaded (the card then shows the step's copy).
  // In the side panel the card only says what was saved; editing lives in the full-screen view.
  const skillActions = userSkills.available ? {
    current: id => (userSkills.byId.has(id) ? userSkills.byId.get(id) : userSkills.loaded ? null : undefined),
    ...(manageSkills && { onEdit: openSkillForm, onToggle: toggleSkill, onDelete: deleteSkill }),
    // A reply's "Your skill · …" and "Method · …" chips (the hub only).
    ...(hub && manageSkills && {
      onOpenSkill: id => { const skill = userSkills.byId.get(id); if (skill) openSkill(skill) },
      onOpenMethod: name => openSkill(null, name)
    })
  } : null

  const newChat = () => {
    overlay.hide()
    if (ARTEMIS_CONVERSATIONS_ENABLED) {
      detachAll()
      setConversation(null)
      setCurrentConversationId(null)
      saved.forgetEarlier()
      dispatchChat({ type: 'reset', messages: [] })
      saved.loadList()
    } else {
      stopAll()
      archiveCurrentChat()
      dispatchChat({ type: 'reset', messages: currentChat() })
    }
    setView('chat')
    setQuestionString('')
  }

  // Plan with Artemis (Hunt Planner): the panel opens on Artemis asking what the user wants to hunt.
  // props.intake 'fresh' starts a new chat for it (the landing page's button); 'ifEmpty' only when
  // there's no chat open yet (the launcher over the planner, which may be reopening one).
  const intakePending = useRef(planner && (props.intake === 'fresh' || (props.intake === 'ifEmpty' && !chatDataRes.length)))
  useEffect(() => {
    if (!intakePending.current) return
    if (chatDataRes.length) {
      if (props.intake === 'fresh') newChat()
      else intakePending.current = false
      return
    }
    intakePending.current = false
    onGetAnswerHandle(PLANNER_INTAKE_OPENER)
  }, [chatDataRes.length])

  const openChat = (chatId, opts = {}) => {
    if (!ARTEMIS_CONVERSATIONS_ENABLED) {
      stopAll()
      setCurrentChat(chatRef.current)
      scrollToEnd.current = true
      dispatchChat({ type: 'reset', messages: openPastChat(chatId) })
      setView('chat')
      return
    }
    detachAll()
    const reopening = chatId === conversationRef.current
    const row = saved.rows.find(r => r.id === chatId)
    const groupChat = opts.group ?? isGroup(row)
    saved.open(chatId, { group: groupChat })
      .then(messages => {
        if (!messages) return showToast({ text: 'That chat is gone' })
        // The alerts inbox (WEB-7145) counts unread alerts like a group counts messages.
        const alertsChat = isAlertsChat(row) || messages.some(m => m.kind === 'alert')
        if ((groupChat || (alertsChat && !hub)) && saved.lastSeq()) {
          props.markArtemisRead(chatId, saved.lastSeq()).then(() => { if (alertsChat) saved.loadList() }).catch(() => {})
        }
        setConversation(chatId)
        setCurrentConversationId(chatId)
        if (hub) setSection(alertsChat ? 'alerts' : (groupChat || isSession(row, opened)) ? 'sessions' : 'chats')
        setHighlightId(null)
        pendingScroll.current = opts.message && !(hub && alertsChat) ? { id: opts.message, tries: 0 } : null
        if (hub && alertsChat) {
          alertsSeenAt.current = (row && row.at) || Date.now()
          readPosted.current = null
          setSelectedAlert(current => opts.message || (reopening ? current : null))
        }
        scrollToEnd.current = true
        dispatchChat({ type: 'reset', messages })
        setView('chat')
      })
      .catch(() => showToast({ text: 'Couldn’t open that chat. Try again.' }))
  }

  const loadEarlier = () => {
    const container = chatContainerRef.current
    const fromBottom = container ? container.scrollHeight - container.scrollTop : 0
    scrollToEnd.current = false
    saved.loadEarlier(conversationRef.current)
      .then(messages => {
        if (!messages) return
        dispatchChat({ type: 'prepend', messages: mergeEarlier(messages, chatRef.current) })
        // Keep the reader where they were.
        requestAnimationFrame(() => { if (container) container.scrollTop = container.scrollHeight - fromBottom })
      })
      .catch(() => showToast({ text: 'Couldn’t load earlier messages' }))
  }

  const deleteChat = chatId => {
    saved.remove(chatId)
      .then(() => { if (conversationRef.current === chatId) newChat() })
      .catch(() => showToast({ text: 'Couldn’t delete that chat' }))
  }

  // The open session's menu and members (group chats, as on Android).
  const me = members.find(m => String(m.UserId) === String(meId))
  const isOwner = !me || me.Role === 'owner'
  const sessionTitle = (openRowState && openRowState.title !== 'New chat' && openRowState.title) || (chatDataRes[0] && chatDataRes[0].question) || ''
  const renameSession = title => {
    const id = conversationRef.current
    setMenuOpen(false)
    props.updateArtemisConversation(id, { Title: title })
      .then(() => { saved.loadList(); showToast({ text: 'Renamed' }) })
      .catch(err => showToast({ text: (err && err.code === 'forbidden') ? 'Only the owner can rename this session' : 'Couldn’t rename it. Try again.' }))
  }
  // Archive, from the ⋯ menu or a side-panel history row: for this user only, it leaves every list but the
  // hub's Archived chip, and Undo brings it back. The alerts inbox is never offered it; a server with
  // API-3922 refuses it anyway (409 alerts_conversation), which needs no word to the user.
  const archiveConversation = id => {
    setMenuOpen(false)
    if (!id) return
    const wasOpen = conversationRef.current === id
    props.updateArtemisConversation(id, { Archived: true })
      .then(() => {
        if (wasOpen) newChat()
        else saved.loadList()
        showToast({
          text: 'Archived', button: 'Undo',
          run: () => props.updateArtemisConversation(id, { Archived: false }).then(() => { saved.loadList(); if (wasOpen) openChat(id) }).catch(() => {})
        })
      })
      .catch(err => {
        if (err && err.code === 'alerts_conversation') saved.loadList()
        else showToast({ text: 'Couldn’t archive it. Try again.' })
      })
  }
  const archiveSession = () => archiveConversation(conversationRef.current)
  // The hub's ⋯ menu also reads aloud, where the browser can.
  const hubReadAloud = ARTEMIS_AGENT_ENABLED && speaker.supported ? () => { setMenuOpen(false); setVoiceMenuOpen(true) } : null
  const deleteSession = () => {
    const leaving = group && !isOwner
    setMenuOpen(false)
    setMembersOpen(false)
    saved.remove(conversationRef.current)
      .then(() => { newChat(); showToast({ text: leaving ? 'You left the session' : 'Deleted' }) })
      .catch(() => showToast({ text: leaving ? 'Couldn’t leave. Try again.' : 'Couldn’t delete it. Try again.' }))
  }
  const removeMember = userId => props.removeArtemisMember(conversationRef.current, userId)
    .then(() => { loadMembers(conversationRef.current); saved.loadList() })
    .catch(err => showToast({ text: (err && err.code === 'forbidden') ? 'Only the owner can remove people' : 'Couldn’t remove them. Try again.' }))
  // Start a session (the Sessions list's +): a new conversation with the scratchpad on and the invite
  // sheet open, so a partner can be asked in before the first question.
  const startSession = () => {
    newChat()
    setSection('sessions')
    props.createArtemisConversation({ scratchpad: true })
      .then(conversation => {
        setOpened(o => rememberSession(o, conversation.Id))
        inviteNext.current = true
        setConversation(conversation.Id)
        setCurrentConversationId(conversation.Id)
        saved.loadList()
      })
      .catch(() => showToast({ text: 'Couldn’t start a session. Try again.' }))
  }

  // Open as session: the same conversation with the scratchpad on. Nothing is copied. The server marks it
  // a session at once (API-3921: PATCH Scratchpad true), so every device lists it under Sessions even if
  // nothing more is sent; a server without that refuses or ignores it, and the next message's
  // Context.Scratchpad still does it (this browser keeps it as a session meanwhile).
  const openAsSession = () => {
    const id = conversationRef.current
    if (id) {
      setOpened(o => rememberSession(o, id))
      setPromoted({ id, after: chatRef.current.length })
      if (!inAlerts) props.updateArtemisConversation(id, { Scratchpad: true }).then(() => saved.loadList()).catch(() => {})
    }
    setSection('sessions')
    setScratchOpen(true)
  }

  // The rail. Chats and Sessions reopen what they last had open (if it's still listed); Alerts opens the
  // alerts conversation; Skills shows the user's skills.
  const goSection = next => {
    setRightOpen(false)
    if (next === 'skills') {
      // From the rail there's no chat to go back to.
      skillsReturn.current = null
      setMethodFocus(null)
      loadBuiltIns()
      setSection('skills')
      setView(v => (v === 'skill-form' ? v : 'skills'))
      return
    }
    if (next === 'alerts') {
      setSection('alerts')
      const inbox = saved.rows.find(isAlertsChat)
      const id = (inbox && inbox.id) || alerts.conversationId
      if (id && id !== conversationRef.current) openChat(id)
      else setView('chat')
      if (alerts.available) alerts.refresh()
      return
    }
    setSection(next)
    setView('chat')
    if (next === section && view === 'chat') return
    const back = lastIn.current[next]
    const backRow = back && saved.rows.find(r => r.id === back)
    if (backRow && sectionFor(backRow, opened) === next) { if (back !== conversationRef.current) openChat(back) }
    else if (openConversationId) newChat()
  }

  // Chats and Sessions each list their own page by API-3909's filters, where the server has them, so neither
  // misses rows past the first page of everything; else both split that page. Reloaded with the list.
  const filtersOn = hub && hasListFilters(saved.rows)
  const [sectionList, setSectionList] = useState({ section: null, rows: [], cursor: null, state: 'idle' })
  const loadSectionList = (which, more = false) => {
    setSectionList(l => ({ ...l, state: 'loading' }))
    return props.fetchArtemisConversations(more && sectionList.section === which ? sectionList.cursor : null, 20, false, listFilter(which))
      .then(page => setSectionList(l => ({
        section: which,
        rows: [...(more && l.section === which ? l.rows : []), ...((page && page.Items) || []).map(conversationRow)],
        cursor: (page && page.NextCursor) || null,
        state: 'loaded'
      })))
      .catch(() => setSectionList(l => ({ ...l, state: 'failed' })))
  }
  useEffect(() => {
    if (filtersOn && (section === 'chats' || section === 'sessions')) loadSectionList(section)
  }, [filtersOn, section, saved.rows])

  // The Archived chip in Chats and Sessions: archived conversations (archived=true), each with Unarchive.
  const [archived, setArchived] = useState({ on: false, rows: [], state: 'idle' })
  const loadArchived = () => {
    setArchived(a => ({ ...a, state: 'loading' }))
    return props.fetchArtemisConversations(null, 50, true)
      .then(page => setArchived(a => ({ ...a, rows: ((page && page.Items) || []).map(conversationRow), state: 'loaded' })))
      .catch(() => setArchived(a => ({ ...a, state: 'failed' })))
  }
  const toggleArchived = () => {
    if (!archived.on) loadArchived()
    setArchived(a => ({ ...a, on: !a.on }))
  }
  const unarchive = id => props.updateArtemisConversation(id, { Archived: false })
    .then(() => { loadArchived(); saved.loadList(); showToast({ text: 'Unarchived' }) })
    .catch(() => showToast({ text: 'Couldn’t unarchive it. Try again.' }))

  // "@you": unread mentions, polled while the page is visible; each toasts once with Reply, which opens the chat.
  // In the full view, where web keeps shared sessions.
  useEffect(() => {
    if (!ARTEMIS_CONVERSATIONS_ENABLED || !full) return
    let stopped = false
    const look = () => {
      if (document.hidden) return
      props.fetchArtemisMentions()
        .then(page => {
          if (stopped) return
          const first = MENTIONS_LOOKED.first
          MENTIONS_LOOKED.first = false
          const fresh = mentionsToToast((page && page.Items) || [], MENTIONS_SEEN, { first, openConversationId: conversationRef.current })
          if (fresh.length === 0) return
          const latest = fresh[0]
          showToast({
            text: fresh.length > 1 ? `${mentionToastText(latest)} (+${fresh.length - 1} more)` : mentionToastText(latest),
            button: 'Reply',
            run: () => openChat(latest.ConversationId, { group: true })
          })
          saved.loadList()
        })
        .catch(() => {})
    }
    look()
    const timer = setInterval(look, MENTIONS_EVERY_MS)
    return () => { stopped = true; clearInterval(timer) }
  }, [])

  // A reply the server was still writing when the chat was opened: fetch it again.
  const refreshChat = () => { if (conversationRef.current) openChat(conversationRef.current) }

  // The alerts inbox on screen when a new alert comes in (the list's 30 s refresh sees an unread message
  // newer than any alert loaded): reload it. The row's count from before it was opened doesn't count.
  // When the hub last opened the inbox: activity newer than that (an alert, or a reply) reloads it.
  const alertsSeenAt = useRef(0)
  const loadedAlertAt = chatDataRes.reduce((latest, t) => (t.kind === 'alert' && t.at > latest ? t.at : latest), 0)
  const newAlertWaiting = inAlerts && !!openRowState && openRowState.unread > 0 && openRowState.at > Math.max(loadedAlertAt, alertsSeenAt.current)
  useEffect(() => {
    if (newAlertWaiting && !working && view === 'chat') refreshChat()
  }, [newAlertWaiting])

  // The hub's Alerts section (WEB-7169): the inbox's alert messages, which of them are unread, the alerts
  // that wrote them (GET Alerts, finished ones included), and the one shown: the one picked, else the newest
  // the filter lets through.
  const alertsRow = saved.rows.find(isAlertsChat)
  const alertTurnList = inAlerts ? chatDataRes.filter(m => m.kind === 'alert') : []
  const alertRead = alertReadState(alertTurnList, alertsRow ? alertsRow.unread : 0, alertReadIds, saved.othersSeqs())
  const alertRecords = new Map(alerts.items.map(a => [a.Id, a]))
  const shownAlert = hub && section === 'alerts'
    ? (alertTurnList.find(t => t.messageId === selectedAlert) || [...alertTurnList].reverse().find(t => alertMatches(t, alertFilter, alertRecords)) || null)
    : null
  const currentBadges = () => ({ ...hubBadges(saved.rows), ...(inAlerts && alertTurnList.length ? { alerts: alertRead.count } : {}) })

  // Reads alerts here, and moves the server's read mark as far as the oldest one still unread.
  const markAlertsRead = ids => {
    const readIds = new Set([...alertReadIds, ...ids])
    setAlertReadIds(readIds)
    const { readUpTo } = alertReadState(alertTurnList, alertsRow ? alertsRow.unread : 0, readIds, saved.othersSeqs())
    const seq = readUpTo === 'all' ? saved.lastSeq() : readUpTo
    if (!seq || !conversationRef.current || (readPosted.current != null && seq <= readPosted.current)) return
    readPosted.current = seq
    props.markArtemisRead(conversationRef.current, seq).then(() => saved.loadList()).catch(() => {})
  }
  // An alert picked, or opened by a link, is read; the one shown by default isn't until it's picked.
  useEffect(() => {
    if (hub && selectedAlert && alertRead.unread.has(selectedAlert)) markAlertsRead([selectedAlert])
  }, [selectedAlert, alertTurnList.length, !!alertsRow])
  // Finished alerts too, for the Finished filter and the alert behind an older message.
  useEffect(() => {
    if (hub && section === 'alerts' && alerts.available && !alerts.includeFinished) alerts.setIncludeFinished(true)
  }, [section, alerts.available])
  // Manage on an alert card: that alert's newest message.
  useEffect(() => {
    if (!hub || !alertFocus || !alertTurnList.length) return
    const newest = [...alertTurnList].reverse().find(t => t.alert && t.alert.AlertId === alertFocus)
    if (newest) { setSelectedAlert(newest.messageId); setAlertFilter('inbox') }
  }, [alertFocus, alertTurnList.length])
  const pickAlert = id => { setAlertFocus(null); setSelectedAlert(id); chatContainerRef.current && chatContainerRef.current.scrollTo(0, 0) }

  // Alert cards' Manage, and the inbox's settings button: the settings screen, at that alert.
  // In the hub, the Alerts section with the alert in its right column.
  const manageAlerts = alerts.available ? id => { setAlertFocus(id || null); if (hub) goSection('alerts'); else { alerts.refresh(); setView('alerts') } } : null
  // An alert's last message, from the settings screen.
  const openAlertMessage = last => openChat(last.ConversationId, { message: last.MessageId })

  // What the context chip and its popover say about the view.
  // ...of the scratchpad map while it's open in the full view, else the main map.
  const basemapLayerId = seesScratch ? scratchLayers.basemapId : activeBasemapLayerId(props.activeLayers, props.layersDictionary)
  const overlayIds = seesScratch ? drawnOverlayIds(scratchLayers, props.layersDictionary) : visibleOverlayLayerIds(props.activeLayers, props.layersDictionary, props.layersVisible)
  const layerName = id => (props.layersDictionary[id] && props.layersDictionary[id].name) || `Layer ${id}`
  const zoom = viewTick >= 0 && viewMap && viewMap.getZoom ? viewMap.getZoom() : null
  const contextView = {
    available: ARTEMIS_AGENT_ENABLED && !!viewMap,
    onScratchpad: seesScratch,
    basemapLayerId,
    overlayCount: overlayIds.length,
    refresh: () => setViewTick(t => t + 1),
    rows: [
      full && { k: 'Map', v: seesScratch ? 'The scratchpad map' : 'Your map' },
      viewAreaRow(mapView) && { k: 'Area', v: viewAreaRow(mapView) },
      basemapLayerId != null && { k: 'Basemap', v: layerName(basemapLayerId) },
      Number.isFinite(zoom) && { k: 'Zoom', v: String(Math.round(zoom)) },
      { k: 'Layers', v: overlayIds.length ? overlayIds.map(layerName).join(', ') : 'None' }
    ].filter(Boolean)
  }

  const displayRow = r => ({ id: r.id, title: r.title, at: r.at, time: [timeLabel(r.at), costLabel(r.cost)].filter(Boolean).join(' · '), preview: r.preview, kind: r.kind, unread: r.unread, unreadMentions: r.unreadMentions,
      scratchpadOn: r.scratchpadOn, scratchCount: r.scratchCount, scratchSentCount: r.scratchSentCount,
      // In a shared session, whether this user owns it (and so deletes it for everyone) or leaves it.
      owner: r.kind !== 'group' || ((r.members || []).find(m => String(m.UserId) === String(meId)) || {}).Role === 'owner' })
  const chats = ARTEMIS_CONVERSATIONS_ENABLED
    ? pinAlerts(saved.rows).map(displayRow)
    : pastChats().map(c => ({ id: c.id, title: c.title, at: c.endedAt, time: timeLabel(c.endedAt), preview: chatSubtitle(c.messages) }))
  const hasChat = chatDataRes.length > 0
  // The store starts this at {} and keeps it as the API sent it, so it isn't always a list.
  const openHistory = () => {
    if (view !== 'history' && ARTEMIS_CONVERSATIONS_ENABLED) saved.loadList()
    setView('history')
  }
  // The map panel's View all: the ARTEMIS tab's Chats, where saved chats are listed.
  const viewAll = ARTEMIS_CONVERSATIONS_ENABLED && !full && !planner
    ? () => { requestSection('chats'); props.collapseLeftToolbar(); props.selectTab('artemis') }
    : openHistory
  // The header follows the design's three panel states: home, history, and a chat (back to history).
  const screen = view === 'history' ? 'history' : view === 'chat' && hasChat ? 'thread' : view === 'chat' ? 'home' : 'skills'
  const goBack = () => (screen === 'thread' ? openHistory() : setView('chat'))
  const openRow = ARTEMIS_CONVERSATIONS_ENABLED && conversationRef.current ? chats.find(c => c.id === conversationRef.current) : null
  // A reopened chat's messages carry no times, so its list row's time stands in.
  const lastAt = (hasChat && chatDataRes[chatDataRes.length - 1].startedAt) || (openRow && openRow.at) || null
  const headerTitle = screen === 'history' ? 'History'
    : screen === 'thread' ? ((openRow && openRow.title !== 'New chat' && openRow.title) || chatDataRes[0].question)
    : view === 'skills' || view === 'skill-form' ? 'Skills' : view === 'alerts' ? 'Alerts' : 'Artemis'
  const headerMeta = screen === 'thread' ? [planner ? 'Hunt Planner' : 'Map', timeLabel(lastAt)].filter(Boolean).join(' · ') : null

  // The full view's scratchpad (artemisapi docs/client-guide-scratchpad.md).
  const sendScratch = () => scratch.send()
    .then(result => {
      if (!result) return
      showToast({ text: result.text })
      if ((result.response.Sent || []).length) props.fetchChanges()
    })
    .catch(err => showToast({ text: (err && err.userMessage) || 'Couldn’t send to your map. Try again.' }))
  const removeScratch = id => scratch.remove(id).catch(() => showToast({ text: 'Couldn’t remove that item' }))
  const setScratchType = (id, markerTypeId) => scratch.update(id, { MarkerTypeId: markerTypeId })
    .catch(err => showToast({ text: (err && err.code === 'already_sent') ? 'That one is already on your map' : 'Couldn’t set the waypoint type' }))
  const scratchTypes = useMemo(() => markerTypeOptions(props.markerTypes), [props.markerTypes])

  // Invite (full view): a chat needs saving before partners can join it.
  const ensureConversation = () => (conversationRef.current
    ? Promise.resolve(conversationRef.current)
    : props.createArtemisConversation({ scratchpad: true }).then(c => { setOpened(o => rememberSession(o, c.Id)); setConversation(c.Id); saved.loadList(); return c.Id }))
  const inviteApi = {
    friends: props.fetchArtemisFriends,
    add: userIds => ensureConversation()
      .then(id => props.addArtemisMembers(id, userIds).then(r => { setMembers((r && r.Items) || []); saved.loadList() })),
    link: () => ensureConversation()
      .then(id => props.createArtemisInvite(id))
      .then(invite => invite.Url || `${window.location.origin}/artemis?invite=${encodeURIComponent(invite.Token)}`)
  }

  // One turn of the chat: an alert, or a question and Artemis's answer.
  const renderTurn = (message, i) => (message.kind === 'alert'
    ? <AlertMessage key={message.id} message={message} now={now} highlighted={message.messageId === highlightId} onManage={manageAlerts} />
    : <Turn
      key={message.id}
      message={message}
      people={group ? { members, meId } : null}
      latest={i === latestReplyIndex}
      now={now}
      onAsk={onGetAnswerHandle}
      onRetry={m => onGetAnswerHandle(m.question)}
      onFeedback={onFeedback}
      onFeedbackComment={onFeedbackComment}
      onSourceFeedback={onSourceFeedback}
      onCopy={onCopy}
      onPin={scratchpadOn && openConversationId ? onPin : null}
      onToggleLayer={(m, action, visible) => toggleLayer(m.id, action, visible)}
      onUpgrade={() => showHideSubscriptionModal(props.auth)}
      onShowObject={onShowObject}
      onRemoveObject={onRemoveObject}
      onRefresh={refreshChat}
      overlay={overlay}
      skillActions={skillActions}
      onToggleView={(m, action, undo) => toggleView(m.id, action, undo)}
      onApplyChange={applyChange}
      applyTo={scratchMapOn ? 'On your scratchpad map' : 'On your map'}
      onManageAlert={manageAlerts}
      layers={alertLayers}
      onOpenPlanner={openPlanner}
    />)

  // Open as session's one-line note, after the turns the conversation had when it was opened as one.
  const withPromotedNote = turns => {
    if (!promoted || promoted.id !== openConversationId || !scratchpadOn) return turns
    const note = (
      <p key="promoted" className="artemis-hub-promoted" role="status">
        This chat is now a session. New finds go to the scratchpad on the right instead of straight to your map. Same conversation, same history.
      </p>
    )
    return [...turns.slice(0, promoted.after), note, ...turns.slice(promoted.after)]
  }

  const panel = (
    <div className={`artemis-panel ${full ? 'artemis-panel-full' : ''}`}>
      <header className="artemis-header">
        {hub && section === 'alerts' && shownAlert
          ? (
            <>
              <AlertHeader turn={shownAlert} record={alertRecords.get(shownAlert.alert && shownAlert.alert.AlertId)} now={now} />
              {alerts.available && (
                <button type="button" className="artemis-scratch-toggle artemis-hub-narrow-only" aria-expanded={rightOpen} onClick={() => setRightOpen(o => !o)}>
                  <Icon name="bell" size={15} />Watches
                </button>
              )}
            </>
          )
          : full
          ? (
            <>
              <span className="artemis-header-text">
                <span className="artemis-header-title">
                  <span className="artemis-hub-title">{section === 'skills' ? 'Skills' : screen === 'thread' ? headerTitle : inAlerts || section === 'alerts' ? 'Alerts'
                    // A session started with + and renamed before its first message.
                    : (openRow && openRow.title !== 'New chat' && openRow.title) || (scratchpadOn ? 'New session' : 'New chat')}</span>
                  {scratchpadOn && section !== 'skills' && <span className="artemis-hub-chip-session">{group ? 'Shared session' : 'Session'}</span>}
                </span>
                <span className="artemis-header-meta">
                  {section === 'skills' ? 'How you hunt, for Artemis to follow'
                    : group ? membersLine(members, meId)
                    : inAlerts || section === 'alerts' ? 'Reminders and watches from Artemis'
                    : scratchpadOn ? 'Just you · invite a partner'
                    : (screen === 'thread' && timeLabel(lastAt)) || 'Just you and Artemis'}
                </span>
              </span>
              {section !== 'skills' && group && (
                <button type="button" className="artemis-avatars artemis-avatars-button" aria-expanded={membersOpen}
                  aria-label={`${members.length} people and Artemis. Show members`} onClick={() => { setMenuOpen(false); setMembersOpen(o => !o) }}>
                  {members.slice(0, 5).map(m => <Avatar key={m.UserId} url={m.AvatarUrl} initials={m.Initials} name={m.Name} />)}
                  <span className="artemis-avatar artemis-avatar-ai" title="Artemis"><Icon name="sparkle" size={13} /></span>
                </button>
              )}
              {membersOpen && group && (
                <MembersPanel members={members} meId={meId} onRemove={removeMember} onLeave={deleteSession} onClose={() => setMembersOpen(false)} />
              )}
              {/* Every ask has it: the same conversation, with the scratchpad on from its next message. */}
              {section === 'chats' && !scratchpadOn && !inAlerts && screen === 'thread' && (
                <button type="button" className="artemis-hub-open-session" onClick={openAsSession}>
                  <Icon name="pin" size={15} />Open as session
                </button>
              )}
              {section !== 'skills' && scratchpadOn && !inAlerts && (
                <button type="button" className="artemis-invite-button" aria-expanded={inviteOpen} onClick={() => setInviteOpen(o => !o)}>
                  <Icon name="plus" size={15} />Invite
                </button>
              )}
              {section === 'sessions' && scratchpadOn && (
                <button type="button" className={`artemis-scratch-toggle ${scratchOpen ? 'artemis-hub-narrow-only' : ''}`} aria-expanded={scratchOpen && rightOpen}
                  onClick={() => { setScratchOpen(true); setRightOpen(o => !scratchOpen || !o) }}>
                  <Icon name="map" size={15} />
                  {scratch.items.length ? `Scratchpad · ${scratch.items.length}` : 'Scratchpad'}
                </button>
              )}
              {section === 'alerts' && alerts.available && (
                <button type="button" className="artemis-scratch-toggle artemis-hub-narrow-only" aria-expanded={rightOpen} onClick={() => setRightOpen(o => !o)}>
                  <Icon name="bell" size={15} />Watches
                </button>
              )}
              {/* The alerts inbox's menu holds only Read aloud, so it has none where that isn't. */}
              {section !== 'skills' && (!inAlerts || hubReadAloud) && (
                <button type="button" className="artemis-icon-button artemis-header-button artemis-session-menu-button" title="More"
                  aria-label="More" aria-expanded={menuOpen} onClick={() => { setMembersOpen(false); setMenuOpen(o => !o) }}>
                  <Icon name="more" size={19} />
                </button>
              )}
              {menuOpen && (
                <SessionMenu title={sessionTitle} isOwner={isOwner} shared={group} alerts={inAlerts} session={scratchpadOn}
                  conversation={!!openConversationId} onClose={() => setMenuOpen(false)}
                  onMembers={() => { setMenuOpen(false); setMembersOpen(true) }}
                  onRename={renameSession} onArchive={archiveSession} onDelete={deleteSession}
                  onReadAloud={hubReadAloud} />
              )}
              {inviteOpen && !inAlerts && (
                <InvitePanel members={members} onClose={() => setInviteOpen(false)}
                  onDone={text => { setInviteOpen(false); showToast({ text }) }}
                  api={inviteApi} />
              )}
            </>
          )
          : screen === 'home'
          ? (
            <>
              <span className="artemis-badge"><Icon name="sparkle" size={16} /></span>
              <span className="artemis-title">Artemis</span>
              {hasPro && <span className="artemis-pro">PRO</span>}
              <span className="artemis-flex" />
              <button type="button" className="artemis-icon-button artemis-header-button" title="History" aria-label="Conversation history" onClick={openHistory}>
                <Icon name="history" size={19} />
              </button>
            </>
          )
          : (
            <>
              <button type="button" className="artemis-icon-button artemis-header-button artemis-header-back" title="Back" aria-label="Back" onClick={goBack}>
                <Icon name="back" size={19} />
              </button>
              <span className="artemis-header-text">
                <span className="artemis-header-title">{headerTitle}</span>
                {headerMeta && <span className="artemis-header-meta">{headerMeta}</span>}
              </span>
              {/* A saved chat or session's ⋯ menu: Rename, Archive, Delete or Leave (members are the hub's). */}
              {ARTEMIS_CONVERSATIONS_ENABLED && openConversationId && !inAlerts && screen === 'thread' && (
                <button type="button" className="artemis-icon-button artemis-header-button artemis-session-menu-button" title="More"
                  aria-label="More" aria-expanded={menuOpen} onClick={() => setMenuOpen(o => !o)}>
                  <Icon name="more" size={19} />
                </button>
              )}
              <button type="button" className="artemis-icon-button artemis-header-button" title="New chat" aria-label="New chat" onClick={newChat}>
                <Icon name="plus" size={20} />
              </button>
              {menuOpen && openConversationId && !inAlerts && (
                <SessionMenu title={sessionTitle} isOwner={!(openRowState && openRowState.owner === false)} shared={isGroup(openRowState)}
                  session={scratchpadOn} onClose={() => setMenuOpen(false)}
                  onRename={renameSession} onArchive={archiveSession} onDelete={deleteSession} />
              )}
            </>
          )}
        {/* Usage in every panel (API-3797/3800, WEB-7135): the meter, credits and Buy credits. */}
        {/* The hub keeps usage on its rail and Read aloud in the ⋯ menu. */}
        {!full && usageNow.metered && <UsageButton state={usageNow} open={usageMenuOpen} onToggle={() => setUsageMenuOpen(o => !o)} />}
        {!full && usageMenuOpen && usageNow.metered && <UsageMenu state={usageNow} detail={usage} onClose={() => setUsageMenuOpen(false)} />}
        {!full && ARTEMIS_AGENT_ENABLED && speaker.supported && (
          <button type="button" className={`artemis-icon-button artemis-header-button artemis-voice-button ${speaker.enabled ? 'artemis-header-button-on' : ''}`}
            title="Read aloud" aria-label="Read aloud" aria-haspopup="dialog" aria-expanded={voiceMenuOpen}
            onClick={() => setVoiceMenuOpen(open => !open)}>
            <Icon name={speaker.enabled ? 'speaker' : 'speakerOff'} size={19} />
          </button>
        )}
        {voiceMenuOpen && <VoiceMenu speaker={speaker} onClose={closeVoiceMenu} />}
        {!full && <button type="button" className="artemis-icon-button artemis-header-button" title="Close Artemis" aria-label="Close Artemis" onClick={props.onClose || props.collapseLeftToolbar}>
          <Icon name="close" size={20} />
        </button>}
      </header>

      <div className="chat-container artemis-scroll" ref={chatContainerRef}>
        {view === 'skill-form'
          ? <SkillForm key={editingSkill ? editingSkill.Id : 'new'} skill={editingSkill} limits={userSkills.limits} builtIns={builtInSkills}
              loadBuiltIn={props.fetchArtemisBuiltInSkill} onSave={saveSkill} onCancel={closeSkillForm} />
          : view === 'alerts'
          ? <AlertsView alerts={alerts} focusId={alertFocus} onBack={() => setView('chat')} onOpenLast={openAlertMessage}
              onAsk={q => { newChat(); setQuestionString(q) }} />
          : hub && section === 'alerts' && inAlerts
          ? (shownAlert
            ? (
              <AlertDetail turn={shownAlert} record={alertRecords.get(shownAlert.alert && shownAlert.alert.AlertId)} alerts={alerts} now={now}>
                {repliesAbout(chatDataRes, shownAlert.messageId).map(m => renderTurn(m, chatDataRes.indexOf(m)))}
              </AlertDetail>
            )
            : <p className="artemis-muted artemis-hub-center-empty">Nothing here for this filter.</p>)
          : hub && section === 'alerts' && !inAlerts && !hasChat
          ? <p className="artemis-muted artemis-hub-center-empty">No alerts yet. Artemis writes here when a reminder is due or something you watch changes. Set one up in any chat: “remind me 2 weeks before my next draw closes”.</p>
          : view === 'skills' && hub
          ? <p className="artemis-muted artemis-hub-center-empty">Pick a skill to edit it, or add one. Artemis follows a skill when a question fits what you said it’s for.</p>
          : view === 'skills'
          ? <SkillsView skills={userSkills.skills} limits={userSkills.limits} notice={skillsNotice} onAdd={() => openSkillForm(null)}
              onToggle={toggleSkill} onEdit={openSkillForm} onDelete={deleteSkill} onBack={() => setView('chat')} />
          : view === 'history'
          ? (
            <PastChats chats={chats} onOpen={openChat}
              saved={ARTEMIS_CONVERSATIONS_ENABLED}
              onDelete={ARTEMIS_CONVERSATIONS_ENABLED ? deleteChat : null}
              onArchive={ARTEMIS_CONVERSATIONS_ENABLED ? archiveConversation : null}
              state={ARTEMIS_CONVERSATIONS_ENABLED ? saved.listState : 'loaded'}
              hasMore={ARTEMIS_CONVERSATIONS_ENABLED && saved.hasMore}
              onMore={more => saved.loadList(more)} />
          )
          : !hasChat
            ? <Welcome surface={planner ? 'planner' : scratchpadOn ? 'session' : full ? 'full' : 'map'} onAsk={onGetAnswerHandle} recentChats={full ? [] : chats.slice(0, RECENT_COUNT)} onOpenChat={openChat} onViewAll={viewAll} mapView={mapView}
                skillsSection={manageSkills && ARTEMIS_AGENT_ENABLED && userSkills.available ? (
                  <WelcomeSkills skills={userSkills.skills} onAdd={() => openSkillForm(null)} onManage={() => (hub ? goSection('skills') : setView('skills'))}
                    onToggle={toggleSkill} onEdit={openSkillForm} />
                ) : null} />
            : [
              saved.hasEarlier && (
                <button key="earlier" type="button" className="artemis-small-button artemis-load-more" disabled={saved.loadingEarlier} onClick={loadEarlier}>
                  {saved.loadingEarlier ? 'Loading…' : 'Load earlier messages'}
                </button>
              ),
              ...withPromotedNote(chatDataRes.map(renderTurn))
            ]}
      </div>

      {group && typingLine(typing) && <div className="artemis-typing" role="status" aria-live="polite">{typingLine(typing)}</div>}
      {(notice => notice && !(notice.dismissible && noticeKey(notice, usage) === dismissedUsageNotice) && (
        <div className={`artemis-usage-notice artemis-usage-notice-${notice.kind}`} role="status">
          <Icon name={notice.kind === 'limit' ? 'lock' : 'chart'} size={15} />
          <span className="artemis-flex">{notice.text}</span>
          {notice.buyUrl && <a className="artemis-usage-buy" href={notice.buyUrl} target="_blank" rel="noopener noreferrer">{notice.kind === 'limit' ? 'Buy more' : 'Buy credits'}</a>}
          {notice.dismissible && (
            <button type="button" className="artemis-icon-button artemis-icon-button-sm artemis-usage-dismiss" title="Dismiss" aria-label="Dismiss"
              onClick={() => { const key = noticeKey(notice, usage); dismissNotice(key); setDismissedUsageNotice(key) }}>
              <Icon name="close" size={14} />
            </button>
          )}
        </div>
      ))(usageNotice(usageNow, { group, buyUrl }))}
      {/* Nothing to ask in the hub's Skills or Alerts, or in the alerts inbox on the map's side panel (WEB-7173):
          Artemis would answer about the newest alerts, not the one being read; questions about an alert go in a chat. */}
      {(hub ? section === 'alerts' : inAlerts) && (
        <div className="artemis-inbox-no-ask">
          <span className="artemis-flex">To ask about an alert, start a new chat.</span>
          {/* In the hub, a new chat under Chats. */}
          <button type="button" className="artemis-small-button artemis-small-button-go"
            onClick={() => { if (hub) { setSection('chats'); setRightOpen(false) } newChat() }}>New chat</button>
        </div>
      )}
      {!(hub && (section === 'skills' || section === 'alerts')) && !inAlerts && <Composer
        mentionOptions={group ? mentionOpts : null}
        groupPlaceholder={group ? 'Message the group — @Artemis to bring in the agent' : null}
        input={questionString}
        onInput={setQuestionString}
        onSend={() => onGetAnswerHandle()}
        onStop={stopAll}
        working={working}
        hasChat={hasChat}
        answering={chatDataRes.length > 0 && isAsking(chatDataRes[chatDataRes.length - 1], true)}
        view={contextView}
        models={models}
        selectedModel={selectedModel}
        onSelectModel={setSelectedModel}
        about={about ? { name: about.name, onDrop: () => setDroppedSelection(props.selectedObjId) } : null}
        dictation={ARTEMIS_AGENT_ENABLED ? {
          ...dictationHook,
          // A new dictation stops any reading, and continues what's already in the box.
          start: () => { silence(); dictationHook.start(questionString) }
        } : null}
        speaking={speaker.speaking}
        onStopSpeaking={silence}
      />}

      <MapToast toast={toast} onAction={onToastAction} />
    </div>
  )
  if (!full) return panel
  const pickedSkill = skillPick && skillPick.draft ? null
    : (skillPick && userSkills.byId.get(skillPick.id)) || (section === 'skills' && !skillPick && !methodFocus ? userSkills.skills[0] || null : null)
  const skillsOn = manageSkills && ARTEMIS_AGENT_ENABLED && userSkills.available
  const hubSections = ['chats', 'sessions', ...(alerts.available || saved.rows.some(isAlertsChat) ? ['alerts'] : []), ...(skillsOn ? ['skills'] : [])]
  return (
    <div className={`artemis-full artemis-hub ${rightOpen ? 'artemis-hub-right-open' : ''}`}>
      <HubRail section={section} sections={hubSections} onSection={goSection} badges={currentBadges()}
        usage={usageNow} usageOpen={usageMenuOpen} onUsage={() => setUsageMenuOpen(o => !o)} user={props.user} />
      {usageMenuOpen && usageNow.metered && (
        <div className="artemis-panel artemis-hub-usage-menu">
          <UsageMenu state={usageNow} detail={usage} onClose={() => setUsageMenuOpen(false)} />
        </div>
      )}
      {(section === 'chats' || section === 'sessions') && (
        <ConversationList section={section} opened={opened} activeId={openConversationId}
          {...(filtersOn && sectionList.section === section
            ? { rows: filteredRows(section, sectionList.rows, saved.rows, opened).map(displayRow), state: sectionList.state,
                hasMore: !!sectionList.cursor, onMore: more => loadSectionList(section, more) }
            : { rows: chats, state: saved.listState, hasMore: saved.hasMore, onMore: more => saved.loadList(more) })}
          onOpen={openChat}
          onNew={section === 'sessions' ? startSession : newChat} onDelete={deleteChat}
          archived={{ ...archived, rows: archived.rows.map(displayRow), onToggle: toggleArchived, onUnarchive: unarchive }} />
      )}
      {section === 'alerts' && (
        <AlertList turns={alertTurnList} unread={alertRead.unread} selectedId={shownAlert && shownAlert.messageId} filter={alertFilter}
          onFilter={f => { setAlertFilter(f); setSelectedAlert(null) }} records={alertRecords} onSelect={pickAlert}
          onMarkAll={() => markAlertsRead(alertTurnList.map(t => t.messageId))} loading={!alerts.loaded && !inAlerts}
          sub={alerts.available ? `${inAlerts ? alertRead.count : (alertsRow ? alertsRow.unread : 0)} new · ${alerts.items.filter(x => x.Status === 'active').length} running` : 'Reminders and watches from Artemis'} />
      )}
      {section === 'skills' && (
        <SkillList skills={userSkills.skills} limits={userSkills.limits} builtIns={builtInSkills} selectedId={pickedSkill && pickedSkill.Id}
          onSelect={skill => setSkillPick({ id: skill.Id })} onToggle={toggleSkill} notice={skillsNotice} loading={!userSkills.loaded}
          onNew={() => setSkillPick({ draft: emptySkillForm(), n: Date.now() })} />
      )}
      {section !== 'skills' ? panel
        : (pickedSkill || (skillPick && skillPick.draft))
          ? (
            <SkillEditor key={pickedSkill ? `skill-${pickedSkill.Id}` : `draft-${skillPick.n}`} skill={pickedSkill} draft={skillPick && skillPick.draft}
              limits={userSkills.limits} builtIns={builtInSkills} savedAt={pickedSkill ? skillSavedAt[pickedSkill.Id] : null} now={now}
              onSave={payload => saveHubSkill(pickedSkill, payload)} onDelete={deleteSkill}
              onBack={skillsReturn.current ? { label: 'Back to the chat', run: () => { const back = skillsReturn.current; skillsReturn.current = null; openChat(back.id) } } : null} />
          )
          : (
            <div className="artemis-panel artemis-panel-full artemis-hub-editor">
              {/* Opened from a "Method · …" chip: back to that chat. */}
              {skillsReturn.current && (
                <header className="artemis-header">
                  <button type="button" className="artemis-icon-button artemis-header-button" title="Back to the chat" aria-label="Back to the chat"
                    onClick={() => { const back = skillsReturn.current; skillsReturn.current = null; openChat(back.id) }}>
                    <Icon name="back" size={19} />
                  </button>
                  <span className="artemis-header-text"><span className="artemis-header-title">Artemis’s methods</span><span className="artemis-header-meta">Make one yours to change how Artemis uses it</span></span>
                </header>
              )}
              <p className="artemis-muted artemis-hub-center-empty">Pick a skill to edit it, add one with +, or make one of Artemis’s methods yours. Artemis follows a skill when a question fits what you said it’s for.</p>
            </div>
          )}
      {section === 'chats' && (
        <SeesPanel view={contextView} onAsk={onGetAnswerHandle}
          starters={[STARTER_SECTIONS[0].items[0], 'Which unit gives me the best odds?', 'Watch this unit for closures and season changes']} />
      )}
      {section === 'sessions' && scratchpadOn && scratchOpen && (
        <Scratchpad scratch={scratch} typeOptions={scratchTypes} onSend={sendScratch} onRemove={removeScratch} onSetType={setScratchType}
          onClose={() => { setScratchOpen(false); setScratchExpanded(false); setRightOpen(false) }} preview={scratchPreview} map={scratchMapProps}
          expanded={scratchExpanded} onToggleExpand={() => setScratchExpanded(x => !x)} />
      )}
      {section === 'skills' && (
        <MethodsColumn builtIns={builtInSkills} skills={userSkills.skills} limits={userSkills.limits} focus={methodFocus} busy={makingMine} onMakeMine={makeMine} />
      )}
      {section === 'alerts' && alerts.available && (
        <AlertsRight alerts={alerts} selectedAlertId={(shownAlert && shownAlert.alert && shownAlert.alert.AlertId) || alertFocus}
          onPickAlert={a => { if (a.LastMessage) pickAlert(a.LastMessage.MessageId) }} onVerifyNumber={null} />
      )}
    </div>
  )
}

// In Hunt Planner (surface 'planner') Artemis reads the planner's map and selections.
const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  mapReference: ownProps.surface === 'planner'
    ? (typeof state.huntplannerMapReference === 'function' ? state.huntplannerMapReference() : null)
    : state.mapReference(),
  huntPlannerSelectedOptions: state.huntPlannerSelectedOptions,
  huntplannerStatesData: state.huntplannerStatesData,
  huntplannerMorefiltersState: state.huntplannerMorefilters,
  // The marker editor's list, for typing scratchpad waypoints.
  markerTypes: state.markerTypes35 && state.markerTypes35.length ? state.markerTypes35 : state.markerTypes25,
  auth: state.auth.token,
  activeLayers: (state.userSettings.find(setting => setting.settingId === 1) || {}).valueArray || [],
  layersDictionary: state.layersDictionary || {},
  layersVisible: state.layersVisible,
  // For the scratchpad map's own layers (full view).
  filters: state.filters,
  productionLayers: state.productionLayers,
  selectedObjId: state.selectedObjId,
  states: state.states,
  markers: state.markers,
  lines: state.lines,
  polygons: state.polygons,
  circles: state.circles,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  dislikeOnSuggestionQuestion: (payload => dispatch(dislikeOnSuggestionQuestion(payload))),
  feedbackOnAnswer: (payload) => dispatch(feedbackOnAnswer(payload)),
  feedbackCommentOnAnswer: (payload) => dispatch(feedbackCommentOnAnswer(payload)),
  fetchSuggestedQuestions: (payload) => dispatch(fetchSuggestedQuestions(payload)),
  postArtemisQuestion: (question, callbacks, modelKey) => dispatch(postArtemisQuestion(question, callbacks, modelKey)),
  fetchArtemisModels: () => dispatch(fetchArtemisModels()),
  handleArtemisAgentEvent: event => dispatch(handleArtemisAgentEventAction(event)),
  refreshAfterArtemisReply: savedObjects => dispatch(refreshAfterArtemisReplyAction(savedObjects)),
  fetchArtemisScratch: id => dispatch(fetchArtemisScratchAction(id)),
  addArtemisScratchItem: (id, item) => dispatch(addArtemisScratchItemAction(id, item)),
  deleteArtemisScratchItem: (id, itemId) => dispatch(deleteArtemisScratchItemAction(id, itemId)),
  updateArtemisScratchItem: (id, itemId, changes) => dispatch(updateArtemisScratchItemAction(id, itemId, changes)),
  sendArtemisScratch: (id, itemIds) => dispatch(sendArtemisScratchAction(id, itemIds)),
  fetchChanges: () => dispatch(fetchChangesAction()),
  fetchArtemisMembers: id => dispatch(fetchArtemisMembersAction(id)),
  addArtemisMembers: (id, userIds) => dispatch(addArtemisMembersAction(id, userIds)),
  createArtemisInvite: id => dispatch(createArtemisInviteAction(id)),
  acceptArtemisInvite: token => dispatch(acceptArtemisInviteAction(token)),
  setArtemisTyping: (id, typing) => dispatch(setArtemisTypingAction(id, typing)),
  pollArtemisMessages: (id, afterSeq) => dispatch(pollArtemisMessagesAction(id, afterSeq)),
  markArtemisRead: (id, seq) => dispatch(markArtemisReadAction(id, seq)),
  fetchArtemisFriends: () => dispatch(fetchArtemisFriendsAction()),
  removeArtemisMember: (id, userId) => dispatch(removeArtemisMemberAction(id, userId)),
  updateArtemisConversation: (id, patch) => dispatch(updateArtemisConversationAction(id, patch)),
  fetchArtemisMentions: () => dispatch(fetchArtemisMentionsAction()),
  fetchArtemisUsage: () => dispatch(fetchArtemisUsageAction()),
  fetchArtemisAlerts: includeFinished => dispatch(fetchArtemisAlertsAction(includeFinished)),
  updateArtemisAlert: (id, patch) => dispatch(updateArtemisAlertAction(id, patch)),
  deleteArtemisAlert: id => dispatch(deleteArtemisAlertAction(id)),
  fetchArtemisAlertSettings: () => dispatch(fetchArtemisAlertSettingsAction()),
  saveArtemisAlertSettings: settings => dispatch(saveArtemisAlertSettingsAction(settings)),
  runSetLayerVisibility: input => dispatch(runSetLayerVisibilityAction(input)),
  showArtemisObject: result => dispatch(showArtemisObjectAction(result, ownProps.surface)),
  removeArtemisObject: result => dispatch(removeArtemisObjectAction(result)),
  showArtemisOverlay: focus => dispatch(showArtemisOverlayAction(focus, ownProps.surface)),
  moveArtemisMap: view => dispatch(moveArtemisMapAction(view, ownProps.surface)),
  runSetMapView: input => dispatch(runSetMapViewAction(input)),
  clearArtemisOverlay: () => dispatch(clearArtemisOverlayAction()),
  collapseLeftToolbar: () => dispatch(collapseLeftToolbarAction()),
  createArtemisConversation: options => dispatch(createArtemisConversationAction(options)),
  fetchArtemisConversations: (cursor, limit, archived, filter) => dispatch(fetchArtemisConversationsAction(cursor, limit, archived, filter)),
  fetchArtemisConversationMessages: (id, beforeSeq) => dispatch(fetchArtemisConversationMessagesAction(id, beforeSeq)),
  deleteArtemisConversation: id => dispatch(deleteArtemisConversationAction(id)),
  cancelArtemisMessage: (id, messageId) => dispatch(cancelArtemisMessageAction(id, messageId)),
  artemisMessageFeedback: (id, messageId, feedback) => dispatch(artemisMessageFeedbackAction(id, messageId, feedback)),
  postArtemisConversationMessage: (id, question, options, modelKey) => dispatch(postArtemisConversationMessageAction(id, question, options, modelKey)),
  fetchArtemisView: (lat, lng) => dispatch(fetchArtemisViewAction(lat, lng)),
  fetchArtemisSkills: () => dispatch(fetchArtemisSkillsAction()),
  fetchArtemisBuiltInSkills: () => dispatch(fetchArtemisBuiltInSkillsAction()),
  fetchArtemisBuiltInSkill: name => dispatch(fetchArtemisBuiltInSkillAction(name)),
  createArtemisSkill: skill => dispatch(createArtemisSkillAction(skill)),
  updateArtemisSkill: (id, patch) => dispatch(updateArtemisSkillAction(id, patch)),
  deleteArtemisSkill: id => dispatch(deleteArtemisSkillAction(id)),
  transcribeArtemisAudio: (wav, context) => dispatch(transcribeArtemisAudioAction(wav, context)),
  speakArtemisText: (request, signal) => dispatch(speakArtemisTextAction(request, signal)),
  fetchArtemisVoices: () => dispatch(fetchArtemisVoicesAction()),
  applyDeepLinkLayers: layerIds => dispatch(applyDeepLinkLayersAction(layerIds)),
  runSetPlannerFilters: input => dispatch(runSetPlannerFiltersAction(input)),
  huntPlannerActiveOptions: selection => dispatch(huntPlannerActiveOptionsAction(selection)),
  selectTab: tab => dispatch(selectedTabAction(tab))
})

export default connect(mapStateToProps, mapDispatchToProps)(Chatbox)
